jQuery(document).ready(function ($) {
  //password page scripts
  $(".anchors").click(function () {
    var active_policy_area = $(this).attr("data-active-policy");
    $(".row_1").addClass("remove_area");
    $(".general_policy").removeClass("active_policy");
    $("#" + active_policy_area).addClass("active_policy");
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      800
    );
  });
  $(".go_back").click(function () {
    $(".general_policy").removeClass("active_policy");
    $(".row_1").removeClass("remove_area");
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      800
    );
  });

  //HEADER//
  var $section1 = $('.announcement-bar-section');
  var $section2 = $('.section-header');

    function updateSticky() {
        if ($section1.find('.make_it_stick').length > 0) {
            $section1.addClass('sticky'); // make section 1 sticky
            $section2.css('top', $section1.outerHeight() + 'px'); // section 2 below section 1
        } else {
            $section1.removeClass('sticky'); // remove sticky if no child
            $section2.css('top', '0px'); // reset section 2 top
        }
    }

    // Run initially
    updateSticky();

    // Observe dynamic changes in Section 1
    var observer = new MutationObserver(updateSticky);
    observer.observe($section1[0], { childList: true, subtree: true, attributes: true });
  //HEADER//

  //main site scripts

  //adding class to brand logo in header so that initially logo will overflow the header
  $(".header .header__heading-link").removeClass("styled_header");
  $(".header").removeClass("styled_header");

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // if (scroll >= 35) {
    if (scroll >= 2) {
      $(".shopify-section-group-header-group").addClass("darkHeader");
      $(".header .header__heading-link").addClass("styled_header");
      $(".header").addClass("styled_header");
    } else {
      $(".shopify-section-group-header-group").removeClass("darkHeader");
      $(".header .header__heading-link").removeClass("styled_header");
      $(".header").removeClass("styled_header");
    }
  });
  var scroll = $(window).scrollTop();
  // if (scroll >= 35) {
  if (scroll >= 2) {
    $(".shopify-section-group-header-group").addClass("darkHeader");
    $(".header .header__heading-link").addClass("styled_header");
    $(".header").addClass("styled_header");
  } else {
    $(".shopify-section-group-header-group").removeClass("darkHeader");
    $(".header .header__heading-link").removeClass("styled_header");
    $(".header").removeClass("styled_header");
  }

  //functionality for best sellers and new arrivals
  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  if (getUrlParameter("sort_by") === "best-selling") {
    $("#HeaderMenu-best-sellers")
      .find("span")
      .addClass("header__active-menu-item");
  }
  if (getUrlParameter("sort_by") === "created-descending") {
    $("#HeaderMenu-new-arrivals")
      .find("span")
      .addClass("header__active-menu-item");
  }
  //functionality for best sellers and new arrivals

  ///////////////// DROPDOWN MENU /////////////////
  //dropdown meag menus
  $(".mega-menu").attr("open", "true");
  $(".mega-menu").click(function (e) {
    e.preventDefault();
    $(".mega-menu").attr("open", "true");
    if ($(this).hasClass("expand")) {
      $(this).removeClass("expand");
      $("header").removeClass("header_overlay_2");
    } else {
      $(".mega-menu").removeClass("expand");
      $(this).addClass("expand");
      $("header").addClass("header_overlay_2");
    }
    //making anchor links inside the dropdown menu clickable which
    //is beng prevented by prevent default
    $(this)
      .find("a")
      .on("click touchend", function (e) {
        var el = $(this);
        var link = el.attr("href");
        window.location = link;
      });
    // // Preventing the event from bubbling up to document
    // e.stopPropagation();
  });
  $(document).click(function (e) {
    if (!$(e.target).closest(".expand").length) {
      // Check if the clicked element is not a descendant of an element with the class .expand
      $(".expand").attr("open", "true");
      $(".mega-menu").removeClass("expand");
      $("header").removeClass("header_overlay_2");
    }
  });
  // Contextmenu event for document
  $(document).on("contextmenu", function (e) {
    // Prevent the default context menu behavior
    // e.preventDefault();
    // Allow the default context menu behavior
    setTimeout(function () {
      // Check if the clicked element is not a descendant of an element with the class .expand
      if (!$(e.target).closest(".expand").length) {
        $(".expand").attr("open", "true");
        $(".mega-menu").removeClass("expand");
        $("header").removeClass("header_overlay_2");
      }
    }, 10);
  });

  ///////////////// DROPDOWN MENU /////////////////

  ///////////////// CLIPPING STYLE /////////////////
  function updateClipPath() {
    const clippedBoxes = document.querySelectorAll(".clipped_pattern");

    // Define the size of the clipped corners
    const clipSize = 16; // Adjust this value as needed

    clippedBoxes.forEach((clippedBox) => {
      clippedBox.style.setProperty("--clip-top-left-x", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-top-left-y", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-top-right-x", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-top-right-y", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-bottom-right-x", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-bottom-right-y", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-bottom-left-x", `${clipSize}px`);
      clippedBox.style.setProperty("--clip-bottom-left-y", `${clipSize}px`);
    });
  }

  updateClipPath();

  window.addEventListener("resize", updateClipPath);
  document.addEventListener("DOMContentLoaded", updateClipPath);

  ///////////////// CLIPPING STYLE /////////////////

  ///////////////// PARALLAX /////////////////

  window.addEventListener("scroll", function () {
    if (
      document.body.classList.contains("temp_index") &&
      window.innerWidth > 770
    ) {
      const parallax = document.querySelector(".parallax");
      const rect = parallax.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const triggerDistance = 0.05 * windowHeight; // 30vh

      // Check if the element is in the viewport
      if (rect.top < windowHeight && rect.bottom > 0) {
        // Calculate how far the element is from the viewport top
        const distanceFromViewportTop = rect.top;

        // Calculate the progress (from 80% to 0%) based on the distance from the top
        const maxDistance = windowHeight - triggerDistance;
        const progress = Math.max(
          0,
          Math.min((maxDistance - distanceFromViewportTop) / maxDistance, 1)
        ); // Progress between 0 and 1
        const backgroundPositionY = 80 - (95 * progress + 15); // From 80% to 0%

        // Apply the background position
        parallax.style.backgroundPosition = `center ${backgroundPositionY}%`;
      }
    }
  });
  ///////////////// PARALLAX /////////////////

  ///////////////// CONTACT & FAQ PAGE /////////////////

  $(".general_faq .desktop .lefts .child:first").addClass("active");
  $(".general_faq .desktop .rights .child:first").slideDown();
  $(".general_faq .desktop .lefts .child").click(function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".general_faq .desktop .lefts .child").removeClass("active");
      $(this).addClass("active");
      var block = $(this).attr("data-block");
      $(".general_faq .desktop .rights .child").hide();
      $("." + block).slideDown();
    }
  });

  $(".general_faq .mobile .child:first").addClass("active");
  $(".general_faq .mobile .child:first .c_bottoms").slideDown();
  $(".general_faq .mobile .child").click(function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".general_faq .mobile .child").removeClass("active");
      $(this).addClass("active");
      var block = $(this).attr("data-block");
      $(".general_faq .mobile .child .c_bottoms").slideUp();
      $(".general_faq .mobile ." + block).slideDown();
    }
  });

  ///////////////// CONTACT & FAQ PAGE /////////////////

  ///////////////// HULK FORMS HEIGHT /////////////////

  //form on contact page
  var iframe = $(".pxFormGenerator iframe")[0];

  // Listen for messages from the iframe
  window.addEventListener("message", function (event) {
    if (event.data.height !== undefined) {
      var iframeHeightBefore = $(iframe).height();
      // console.log("iframe height before:", iframeHeightBefore);
      // console.log("Received height from iframe:", event.data.height);

      // setting iframe height
      $(iframe).height(event.data.height);
      var iframeHeightAfter = $(iframe).height();
      // console.log("iframe height after:", iframeHeightAfter);
    }
  });

  // Function to request height from the iframe
  function requestIframeHeight() {
    iframe.contentWindow.postMessage("getHeight", "*"); // Use '*' to allow any origin
  }

  // setInterval(requestIframeHeight, 300);
  // if (window.location.pathname.startsWith("/pages/contact")) {
  //   //requesting the iframe height every 300ms
  // }

  ///////////////// HULK FORMS HEIGHT /////////////////

  ///////////////// BLOG PAGE /////////////////
  $(".prd_card_content").click(function () {
    var url = $(this).data("href");
    window.location.href = url;
  });
  //HREF CLICK//
  $(document).on("click", ".href_click", function () {
    // Get the value of data-href attribute
    var url = $(this).data("href");
    if (url) {
      window.location.href = url;
    }
  });
  //HREF CLICK//
  ///////////////// BLOG PAGE /////////////////

  ///////////////// CHECKOUT PAGE /////////////////
  // disabling checkout if required checkbox
  $(".cart__check").css("display", "none");
  if ($("#required_final_sale").is(":checked")) {
    $(".cart__check").css("display", "grid");
  } else {
    $(".cart__check").css("display", "none");
  }
  if ($("body").hasClass("template-cart")) {
    $(".cart__check").addClass("disabled");
    $(".cart__check.disabled").click(function (e) {
      e.stopPropagation();
    });
  }
  // Function to check for value changes in hidden inputs

  $("#required_final_sale").change(function () {
    // Check if the checkbox is checked
    if ($(this).is(":checked")) {
      $(".cart__check").css("display", "grid");
    } else {
      $(".cart__check").css("display", "none");
    }
  });

  ///////////////// CHECKOUT PAGE /////////////////

  ///////////////// COLLECTION PAGE /////////////////

  // $(".custom_sort_opt").click(function(){
  $(document).on("click", ".custom_sort_opt", function () {
    var textValue = $(this).attr("data-value");
    console.log("event initiated");

    // Get the current URL
    var currentUrl = window.location.href;

    // Check if sort_by parameter already exists in the URL
    if (currentUrl.indexOf("sort_by=") === -1) {
      // If sort_by parameter does not exist, add it with the selected value
      var newUrl;
      if (currentUrl.indexOf("?") !== -1) {
        newUrl = currentUrl + "&sort_by=" + textValue;
      } else {
        newUrl = currentUrl + "?sort_by=" + textValue;
      }
      // Redirect to the new URL
      window.location.href = newUrl;
    } else {
      // If sort_by parameter already exists, update its value to the selected value
      var re = new RegExp("([?&])sort_by=([^&]*)", "i");
      var separator = currentUrl.indexOf("?") !== -1 ? "&" : "?";

      // Replace or update the sort_by parameter with the selected value
      var newUrl = currentUrl.replace(re, "$1sort_by=" + textValue);

      // Redirect to the new URL
      window.location.href = newUrl;
    }
  });

  //function to show sorting dropdown
  $(document).on("click", ".inline .sorting", function (event) {
    event.stopPropagation(); // Prevents event from bubbling up

    // Toggle class on .my_own_select within the clicked .facet-filters__field
    var $myOwnSelect = $(this).find(".my_own_select");
    if ($myOwnSelect.hasClass("seleected")) {
      $myOwnSelect.removeClass("seleected");
      console.log("Remove class");
    } else {
      $myOwnSelect.addClass("seleected");
      console.log("Add class");
    }
  });

  // Click event to remove seleected class if clicked outside .sorting
  $(document).on("click", function (event) {
    var $myOwnSelect = $(".my_own_select");
    if (!$(event.target).closest(".sorting").length) {
      $myOwnSelect.removeClass("seleected");
      // console.log("Remove class outside .sorting");
    }
  });

  //load more functionality
  //previous
  // $(document).on("click", ".js-load-more-product-collection", function () {
  //   var $this = $(this),
  //     totalPages = parseInt($("[data-total-pages]").val()),
  //     currentPage = parseInt($("[data-current-page]").val());
  //   //   $this.attr('disabled', true);
  //   //   $this.find('[load-more-text]').addClass('hide');
  //   // $this.find('[loader]').removeClass('hide');
  //   currentPage = currentPage + 1;
  //   $("[data-current-page]").val(currentPage);
  //   console.log("currentPage", currentPage);

  //   var nextUrl = $("[data-next-url]")
  //     .val()
  //     .replace(/page=[0-9]+/, "page=" + currentPage);
  //   //changing current page value on frontend
  //   console.log("nextUrl", nextUrl);

  //   // Store current page state in localStorage
  //   localStorage.setItem("currentPage", currentPage);

  //   //ajax call
  //   $.ajax({
  //     url: nextUrl,
  //     type: "GET",
  //     dataType: "html",
  //     success: function (responseHTML) {
  //       // console.log("responseHTML", responseHTML);
  //       $(".product-grid").append($(responseHTML).find(".product-grid").html());
  //     },
  //     complete: function (responseHTML) {
  //       if (currentPage == totalPages) {
  //         // alert();
  //         //  $this.attr('disabled', false);
  //         //  $this.find('[load-more-text]').removeClass('hide');
  //         //  $this.find('[loader]').addClass('hide');
  //         $(".js-load-more-product-collection").removeClass("keep_loading");
  //         $(".load-more_wrap").hide();

  //         // Get updated pagination URL from the new page's hidden inputs
  //         if(responseHTML){
  //           var updatedNextUrl = $(responseHTML).find("[data-next-url]").val();
  //           if (updatedNextUrl) {
  //             $("[data-next-url]").val(updatedNextUrl);
  //           } else {
  //             console.log("no url");
  //           }
  //         }
  //       }
  //     },
  //   });
  // });
  //previous

  //test//
  
  // TEST 2
  $(document).on("click", ".js-load-more-product-collection", function () {
    var $this = $(this);
    var nextUrl = $("[data-next-url]").val();

    if (!nextUrl) {
      console.log("No next URL found, stopping load more.");
      $(".load-more_wrap").hide();
      return;
    }

    $this.prop("disabled", true).text("Loading...");

    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        var $response = $(responseHTML);

        // Append new products
        $(".product-grid").append($response.find(".product-grid").html());

        // Update the next URL
        var updatedNextUrl = $response.find("[data-next-url]").val();
        if (updatedNextUrl) {
          $("[data-next-url]").val(updatedNextUrl);
          $this.prop("disabled", false).text("Load More");
        } else {
          $(".load-more_wrap").hide();
        }

        // Save updated state in sessionStorage
        sessionStorage.setItem("collectionHtml", $(".product-grid").html());
        var prev_collectionNextUrl = sessionStorage.getItem("collectionNextUrl");
        if(updatedNextUrl){
          // sessionStorage.setItem("collectionNextUrl", updatedNextUrl || "");
          sessionStorage.setItem("collectionNextUrl", updatedNextUrl);
          sessionStorage.setItem("removeLoaMoreBtn", "false");
        }else{
          sessionStorage.setItem("collectionNextUrl", prev_collectionNextUrl);
          sessionStorage.setItem("removeLoaMoreBtn", "true");
        }
        sessionStorage.setItem("collectionScroll", $(window).scrollTop());
        sessionStorage.setItem("collectionUrl", window.location.pathname); // current collection
      },
      error: function () {
        console.error("Failed to load next page.");
        $this.prop("disabled", false).text("Load More");
      },
    });
  });

  //removing removeLoadMoreBtn
  $(document).on("click", "a", function (e) {
    const href = $(this).attr("href");

    if (!href) return; // skip if no href

    // Only act if it's a relative internal link
    if (href.startsWith("/") && !href.includes("/products/")) {
      // You can extend this logic if needed
      if (
        href.includes("/collections/") ||
        href.includes("/page/") ||
        href.includes("/blogs/") || // add more allowed paths if needed
        href.includes("/search")
      ) {
        console.log("Removing removeLoaMoreBtn due to anchor click:", href);
        sessionStorage.removeItem("removeLoaMoreBtn");
      }
    }
  });
  //removing removeLoadMoreBtn

  //removing load more button if session variable is true
  if (sessionStorage.getItem("removeLoaMoreBtn") === "true") {
    $(".load-more_wrap").remove();
  }
  //removing load more button if session variable is true




  //TRACEBACKING
  //testing tracback 6
  // const currentPath = window.location.pathname;
  // const currentCollectionHandle = getCollectionHandleFromPath(currentPath);
  // const isCollectionPage = currentPath.includes("/collections/");

  // // 🔁 Get previously stored handle
  // const savedHandle = sessionStorage.getItem("collectionHandle");
  // const savedHtml = sessionStorage.getItem("collectionHtml");
  // const savedNextUrl = sessionStorage.getItem("collectionNextUrl");
  // const savedScroll =
  //   parseInt(sessionStorage.getItem("collectionScroll"), 10) || 0;

  // //If handle changed → clear all
  // if (
  //   savedHandle &&
  //   currentCollectionHandle &&
  //   savedHandle !== currentCollectionHandle
  // ) {
  //   sessionStorage.removeItem("collectionHtml");
  //   sessionStorage.removeItem("collectionNextUrl");
  //   sessionStorage.removeItem("collectionScroll");
  //   sessionStorage.removeItem("collectionUrl");
  //   sessionStorage.removeItem("collectionHandle");
  //   console.log("collection handle changed — storage cleared");
  // }

  // //Now save current collection handle + URL (after check)
  // if (isCollectionPage && currentCollectionHandle) {
  //   console.log("collection url included");
  //   sessionStorage.setItem("collectionHandle", currentCollectionHandle);
  //   sessionStorage.setItem("collectionUrl", currentPath);
  // }

  // //Restore if everything matches
  // if (
  //   savedHtml &&
  //   savedNextUrl &&
  //   savedHandle &&
  //   currentCollectionHandle &&
  //   savedHandle === currentCollectionHandle
  // ) {
  //   console.log("url match");
  //   $(".product-grid").html(savedHtml);
  //   $("[data-next-url]").val(savedNextUrl);

  //   setTimeout(() => {
  //     window.scrollTo({ top: savedScroll, behavior: "auto" });
  //   }, 100);
  // } else {
  //   console.log("no url match or different collection");
  //   console.log("savedHandle:", savedHandle);
  //   console.log("currentCollectionHandle:", currentCollectionHandle);
  // }

  // // clear on fresh hard visit
  // const navEntry = performance.getEntriesByType("navigation")[0];
  // const isFreshVisit = navEntry && navEntry.type === "navigate";

  // if (isCollectionPage && isFreshVisit) {
  //   console.log("sessionStorage cleared (fresh collection visit)");
  //   sessionStorage.removeItem("collectionHtml");
  //   sessionStorage.removeItem("collectionNextUrl");
  //   sessionStorage.removeItem("collectionScroll");
  //   sessionStorage.removeItem("collectionUrl");
  //   sessionStorage.removeItem("collectionHandle");
  // }

  // //Get /collections/slug
  // function getCollectionHandleFromPath(path) {
  //   const match = path.match(/^\/collections\/([^\/\?]+)/);
  //   return match ? match[1] : null;
  // }
  //testing tracback 6

  //testing tracback 7
  // //Get /collections/slug
  // function getCollectionHandleFromPath(path) {
  //   const match = path.match(/^\/collections\/([^\/\?]+)/);
  //   return match ? match[1] : null;
  // }
  // const currentPath = window.location.pathname;
  // const currentCollectionHandle = getCollectionHandleFromPath(currentPath);
  // const isCollectionPage = currentPath.includes("/collections/");

  // // ✅ Always save current collection handle + URL first (before comparing!)
  // if (isCollectionPage && currentCollectionHandle) {
  //   sessionStorage.setItem("collectionHandle", currentCollectionHandle);
  //   sessionStorage.setItem("collectionUrl", currentPath);
  //   console.log("collection url included");
  // }

  // // 🔁 Now get previously stored handle (AFTER setting it)
  // const savedHandle = sessionStorage.getItem("collectionHandle");
  // const savedHtml = sessionStorage.getItem("collectionHtml");
  // const savedNextUrl = sessionStorage.getItem("collectionNextUrl");
  // const savedScroll = parseInt(sessionStorage.getItem("collectionScroll"), 10) || 0;

  // // 🧹 Clear if handle changed
  // if (savedHandle && currentCollectionHandle && savedHandle !== currentCollectionHandle) {
  //   sessionStorage.removeItem("collectionHtml");
  //   sessionStorage.removeItem("collectionNextUrl");
  //   sessionStorage.removeItem("collectionScroll");
  //   sessionStorage.removeItem("collectionUrl");
  //   sessionStorage.removeItem("collectionHandle");
  //   console.log("collection handle changed — storage cleared");
  // }


  // // 🔁 Clear if fresh hard visit
  // const navEntry = performance.getEntriesByType("navigation")[0];
  // const isFreshVisit = navEntry && navEntry.type === "navigate";

  // if (isCollectionPage && isFreshVisit) {
  //   console.log("sessionStorage cleared (fresh collection visit)");
  //   sessionStorage.removeItem("collectionHtml");
  //   sessionStorage.removeItem("collectionNextUrl");
  //   sessionStorage.removeItem("collectionScroll");
  //   sessionStorage.removeItem("collectionUrl");
  //   sessionStorage.removeItem("collectionHandle");
  // }

  // // 🔁 Restore if all matches
  // if (
  //   savedHtml &&
  //   savedNextUrl &&
  //   savedHandle &&
  //   currentCollectionHandle &&
  //   savedHandle === currentCollectionHandle
  // ) {
  //   console.log("url match");
  //   $(".product-grid").html(savedHtml);
  //   $("[data-next-url]").val(savedNextUrl);

  //   setTimeout(() => {
  //     window.scrollTo({ top: savedScroll, behavior: "auto" });
  //   }, 100);
  // } else {
  //   console.log("no url match or different collection");
  //   console.log("savedHandle:", savedHandle);
  //   console.log("currentCollectionHandle:", currentCollectionHandle);
  // }
  //testing tracback 7

  //testing tracback 8
  function getCollectionHandleFromPath(path) {
    const match = path.match(/^\/collections\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  const currentPath = window.location.pathname;
  const currentCollectionHandle = getCollectionHandleFromPath(currentPath);
  const isCollectionPage = currentPath.includes("/collections/");

  // 🔁 Clear sessionStorage on hard visit BEFORE anything else
  const navEntry = performance.getEntriesByType("navigation")[0];
  const isFreshVisit = navEntry && navEntry.type === "navigate";

  if (isCollectionPage && isFreshVisit) {
    console.log("sessionStorage cleared (fresh collection visit)");
    sessionStorage.removeItem("collectionHtml");
    sessionStorage.removeItem("collectionNextUrl");
    sessionStorage.removeItem("collectionScroll");
    sessionStorage.removeItem("collectionUrl");
    sessionStorage.removeItem("collectionHandle");
  }

  // 🔁 Now get previously stored handle
  const savedHandle = sessionStorage.getItem("collectionHandle");
  const savedHtml = sessionStorage.getItem("collectionHtml");
  const savedNextUrl = sessionStorage.getItem("collectionNextUrl");
  const savedScroll = parseInt(sessionStorage.getItem("collectionScroll"), 10) || 0;

  // 🧹 Clear if handle changed (should be BEFORE restore)
  if (
    savedHandle &&
    currentCollectionHandle &&
    savedHandle !== currentCollectionHandle
  ) {
    sessionStorage.removeItem("collectionHtml");
    sessionStorage.removeItem("collectionNextUrl");
    sessionStorage.removeItem("collectionScroll");
    sessionStorage.removeItem("collectionUrl");
    sessionStorage.removeItem("collectionHandle");
    console.log("collection handle changed — storage cleared");
  }

  // ✅ Only restore AFTER checking everything (not earlier)
  if (
    savedHtml &&
    savedNextUrl &&
    savedHandle &&
    currentCollectionHandle &&
    savedHandle === currentCollectionHandle
  ) {
    console.log("url match");
    $(".product-grid").html(savedHtml);
    $("[data-next-url]").val(savedNextUrl);
    var storedProductId = localStorage.getItem('currentPrdScrollID');
    setTimeout(() => {
      // window.scrollTo({ top: savedScroll, behavior: "auto" });
      if (storedProductId) {
        var $storedProduct = $('#' + storedProductId);
        if ($storedProduct.length) {
            // $('html, body').animate({
            //     scrollTop: $storedProduct.offset().top - ($(window).height() * 0.25)
            // }, 800);
            window.scrollTo({
                top: $storedProduct.offset().top - ($(window).height() * 0.25),
                behavior: 'auto' // No animation
            });
            console.log("Scrolled to:", $storedProduct);
            console.log("Scrolled id:", storedProductId);
        }else{
            // $('html, body').animate({
            //     scrollTop: $productGrid.offset().top - ($(window).height() * 0.25)
            // }, 800);
            window.scrollTo({
                top: $productGrid.offset().top + ($productGrid.height() * 0.95),
                behavior: 'auto' // No animation
            });
            console.log("Not Scrolled to:", $storedProduct);
            console.log("Not Scrolled id:", storedProductId);
        }
        console.log("scrolllllled: ", $storedProduct);
    }else{
        var $productGrid = $('.product-grid');
        // $('html, body').animate({
        //     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
        // }, 700);
        window.scrollTo({
            top: $productGrid.offset().top + ($productGrid.height() * 0.95),
            behavior: 'auto' // No animation
        });
    }
    }, 100);
  } else {
    console.log("no url match or different collection");
    console.log("savedHandle:", savedHandle);
    console.log("currentCollectionHandle:", currentCollectionHandle);
  }

  // ✅ Now — AFTER all logic — save current path & handle
  if (isCollectionPage && currentCollectionHandle) {
    sessionStorage.setItem("collectionHandle", currentCollectionHandle);
    sessionStorage.setItem("collectionUrl", currentPath);
    console.log("collection url included");
  }
  //testing tracback 8
  //TRACEBACKING
  // TEST 2

  ///////////////// COLLECTION PAGE /////////////////

  ///////////////// PRODUCT PAGE /////////////////

  //adding customm zoom on product image for custom prints
  // var $container = $(".custom-image-magnify-hover");
  // var zoomLevel = 1.4; // Magnification level

  // // Cache the dimensions of the container and images for better performance
  // var containerWidth = $container.width();
  // var containerHeight = $container.height();

  // // Add a smooth transition effect
  // $container.css({
  //   transition: "transform 0.2s ease-in-out .01s",
  //   transform: "none", // Default state with no transformation
  // });

  // // Add a click event to enable zoom
  // // $container.on("click", function () {
  // //   // Toggle zoom-enabled class on click
  // //   if (!$container.hasClass("zoom-enabled")) {
  // //     $container.addClass("zoom-enabled");
  // //   }
  // // });
  // // Add a click event to enable zoom
  // $container.on("click", function (event) {
  //   // Check if the zoom-enabled class is already present
  //   event.preventDefault();
  //   if ($container.hasClass("zoom-enabled")) {
  //     return; // Exit if zoom is already enabled
  //   }
  //   // Apply opacity change for 800ms
  //   $container.css({
  //     transition: "opacity 0.4s",
  //     opacity: 0.4,
  //   });

  //   // After 800ms, revert opacity and add zoom-enabled class
  //   setTimeout(function () {
  //     $container.css({
  //       opacity: 1, // Reset opacity back to normal
  //     });

  //     if (!$container.hasClass("zoom-enabled")) {
  //       // Now add the zoom-enabled class
  //       $container.addClass("zoom-enabled");

  //       // Mimic mousemove once at the click point to zoom on that spot
  //       var containerOffset = $container.offset();
  //       var mouseX = event.pageX - containerOffset.left;
  //       var mouseY = event.pageY - containerOffset.top;

  //       // Calculate the percentage of where the mouse is over the container
  //       var percX = (mouseX / containerWidth) * 60;
  //       var percY = (mouseY / containerHeight) * 60;

  //       // Apply scaling and set the transform origin at the click position
  //       $container.css({
  //         "transform-origin": percX + "% " + percY + "%",
  //         transform: "scale(" + zoomLevel + ")",
  //       });
  //     }
  //   }, 400); // Delay class addition for 800ms to allow opacity transition
  // });

  // // On mouse move, apply zoom only if zoom-enabled class is present
  // $container.on("mousemove", function (event) {
  //   if ($container.hasClass("zoom-enabled")) {
  //     var containerOffset = $container.offset();
  //     var mouseX = event.pageX - containerOffset.left;
  //     var mouseY = event.pageY - containerOffset.top;

  //     // Calculate the percentage of where the mouse is over the container
  //     var percX = (mouseX / containerWidth) * 60;
  //     var percY = (mouseY / containerHeight) * 60;

  //     // Apply scaling and set the transform origin
  //     $container.css({
  //       "transform-origin": percX + "% " + percY + "%",
  //       transform: "scale(" + zoomLevel + ")",
  //     });
  //   }
  // });

  // // Reset the zoom and remove the class when the mouse leaves the container
  // $container.on("mouseleave", function () {
  //   if ($container.hasClass("zoom-enabled")) {
  //     // Reset the zoom
  //     $container.css({
  //       transform: "none", // Return to default state
  //     });
  //     // Remove the zoom-enabled class
  //     $container.removeClass("zoom-enabled");
  //   }
  // });
  var $container = $(".custom-image-magnify-hover");
  var zoomLevel = 1.4; // Magnification level
  var smallScreenZoomLevel = 1.2; // Simple zoom for small screens

  // Cache the dimensions of the container and images for better performance
  // Remove the global cache of container dimensions as it varies per container
  // Add a smooth transition effect to all containers
  $container.css({
    transition: "transform 0.2s ease-in-out .01s",
    transform: "none", // Default state with no transformation
  });

  // Add a click event to enable zoom on individual containers
  $container.on("click", function (event) {
    var $this = $(this); // Reference only the clicked container

    // Prevent default behavior and check if the zoom is already enabled
    event.preventDefault();
    if ($(window).width() > 749) {
      if ($this.hasClass("zoom-enabled")) {
        return; // Exit if zoom is already enabled on this specific container
      }

      // Apply opacity change for 800ms on the clicked container
      $this.css({
        transition: "opacity 0.4s",
        opacity: 0.4,
      });

      // After 800ms, revert opacity and add zoom-enabled class
      setTimeout(function () {
        $this.css({
          opacity: 1, // Reset opacity back to normal
        });

        if (!$this.hasClass("zoom-enabled")) {
          // Add the zoom-enabled class to the clicked container
          $this.addClass("zoom-enabled");

          // Mimic mousemove once at the click point to zoom on that spot
          var containerOffset = $this.offset();
          var containerWidth = $this.width();
          var containerHeight = $this.height();
          var mouseX = event.pageX - containerOffset.left;
          var mouseY = event.pageY - containerOffset.top;

          // Calculate the percentage of where the mouse is over the container
          var percX = (mouseX / containerWidth) * 60;
          var percY = (mouseY / containerHeight) * 60;

          // Apply scaling and set the transform origin at the click position
          $this.css({
            "transform-origin": percX + "% " + percY + "%",
            transform: "scale(" + zoomLevel + ")",
          });
        }
      }, 400); // Delay class addition for 800ms to allow opacity transition
      $container.on("mousemove", function (event) {
        var $this = $(this); // Reference only the hovered container
        if ($this.hasClass("zoom-enabled")) {
          var containerOffset = $this.offset();
          var containerWidth = $this.width();
          var containerHeight = $this.height();
          var mouseX = event.pageX - containerOffset.left;
          var mouseY = event.pageY - containerOffset.top;

          // Calculate the percentage of where the mouse is over the container
          var percX = (mouseX / containerWidth) * 60;
          var percY = (mouseY / containerHeight) * 60;

          // Apply scaling and set the transform origin
          $this.css({
            "transform-origin": percX + "% " + percY + "%",
            transform: "scale(" + zoomLevel + ")",
          });
        }
      });
    } else {
      // Small screen behavior (simple scale to 1.2)
      var $zoomIcon = $this.find(".zoomIcon");
      // Toggle zoom icon back to 'fa-search-plus'
      if ($zoomIcon.find("i").hasClass("fa-search-minus")) {
        $zoomIcon
          .find("i")
          .removeClass("fa-search-minus")
          .addClass("fa-search-plus");
      } else {
        // Toggle zoom icon to 'fa-search-minus'
        if ($zoomIcon.find("i").hasClass("fa-search-plus")) {
          $zoomIcon
            .find("i")
            .removeClass("fa-search-plus")
            .addClass("fa-search-minus");
        }
      }

      if ($this.hasClass("zoom-enabled")) {
        // Remove the scale if already zoomed in
        $this.css({
          transform: "none", // Reset zoom
        });
        $this.removeClass("zoom-enabled");
      } else {
        // Scale the container to 1.2
        $this.css({
          transform: "scale(" + smallScreenZoomLevel + ")",
        });
        $this.addClass("zoom-enabled");

        // Detect click outside of the container to remove zoom
        $(document).on("click.zoomOut", function (e) {
          if (!$this.is(e.target) && $this.has(e.target).length === 0) {
            // If clicked outside the container, reset zoom
            $this.css({
              transform: "none",
            });
            $this.removeClass("zoom-enabled");

            // Remove the event handler for outside clicks
            $(document).off("click.zoomOut");
          }
        });
      }
    }
  });

  // On mouse move, apply zoom only if zoom-enabled class is present for the clicked container

  $container.on("mouseleave", function () {
    if ($container.hasClass("zoom-enabled")) {
      // Reset the zoom
      $container.css({
        transform: "none", // Return to default state
      });
      // Remove the zoom-enabled class
      $container.removeClass("zoom-enabled");

      var $this = $(this);
      var $zoomIcon = $this.find(".zoomIcon");
      // Toggle zoom icon back to 'fa-search-plus'
      if ($zoomIcon.find("i").hasClass("fa-search-minus")) {
        $zoomIcon
          .find("i")
          .removeClass("fa-search-minus")
          .addClass("fa-search-plus");
      }
    }
  });
  //adding customm zoom on product image for custom prints

  $("#size_guide_id").on("click", function () {
    $("body").addClass("overflow_hidden");
    $("#modalFrameSize").fadeIn();
  });

  // Close modal when the close icon is clicked
  $(".closeModal").on("click", function () {
    $("body").removeClass("overflow_hidden");
    $("#modalFrameSize").fadeOut();
    $("#image-editor-modal").fadeOut();
  });

  $(".modal .btn_inline .c_button").on("click", function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".modal btn_inline .c_button").removeClass("active");
      $(".modal .btn_inline .c_button").removeClass("active");
      $(this).addClass("active");
      var active_img = $(this).attr("data-size");
      console.log("active: " + active_img);
      $(".guide_img").removeClass("ennable");
      $(".guide_img").addClass("dissable");
      $("#" + active_img).addClass("ennable");
    }
  });

  //onload check on product page which variant is selected for 'SELECT PRODUCT TYPE' AKA 'Style'
  //initial settings
  var choose_product_inputs = document.querySelectorAll('input[name^="Style"]');

  // Function to handle the logic based on the input value for product type
  function checkVariantValue(input) {
    console.log("Checking variant option:", input.value);
    if (input.checked) {
      if (input.value === "Canvas") {
        $(".content_block_Product_Specs_and_Care_Metal").hide();
        $(".content_block_Product_Specs_and_Care_Canvas").show();

        //removing active class from metal blocks
        $(
          ".general_faq .content_block_Product_Specs_and_Care_Metal"
        ).removeClass("active");

        //adding active class to canvas block
        $(".general_faq .content_block_Product_Specs_and_Care_Canvas").addClass(
          "active"
        );
      } else if (input.value == "Metal Prints") {
        //canFrame
        $(".content_block_Product_Specs_and_Care_Canvas").hide();
        $(".content_block_Product_Specs_and_Care_Metal").show();

        //removing active class from canvas blocks
        $(
          ".general_faq .content_block_Product_Specs_and_Care_Canvas"
        ).removeClass("active");

        //adding active class to metal block
        $(".general_faq .content_block_Product_Specs_and_Care_Metal").addClass(
          "active"
        );
      }
    }
    //next hiding unavialble variants
    setTimeout(function () {
      $(".fieldset_size input").each(function () {
        if ($(this).hasClass("disabled")) {
          $(this).hide(); // Hide the input
          console.log("hdiing");
          $(this).next("label").hide(); // Hide the label next to it
        } else {
          $(this).show();
          $(this).next("label").show(); // Hide the label next to it
        }
      });
    }, 20);
  }

  // Traverse through each input and check the value on page load if it's checked
  //for Style variant
  choose_product_inputs.forEach(function (input) {
    if (input.checked) {
      checkVariantValue(input);
    }
  });

  document
    .querySelectorAll('input[name^="Style"]')
    .forEach(function (selectElement) {
      selectElement.addEventListener("change", function (event) {
        console.log("Variant option changed:", event.target.value);
        if (event.target.value == "Canvas") {
          $(".content_block_Product_Specs_and_Care_Metal").hide();
          $(".content_block_Product_Specs_and_Care_Canvas").show();
          console.log("change variant canvas");

          //removing active class from metal blocks
          $(
            ".general_faq .content_block_Product_Specs_and_Care_Metal"
          ).removeClass("active");

          //adding active class to canvas block
          $(
            ".general_faq .content_block_Product_Specs_and_Care_Canvas"
          ).addClass("active");

          //size guide changes
          $("#metal_guide").addClass("dissable");
          $("#metal_guide").removeClass("ennable");
          $("#canvas_guide").addClass("ennable");
          $("#canvas_guide").removeClass("dissable");
          //btn
          $(".c_button[data-size='metal_guide'").removeClass("active");
          $(".c_button[data-size='canvas_guide'").addClass("active");
        } else if (event.target.value == "Metal Prints") {
          //canFrame
          $(".content_block_Product_Specs_and_Care_Canvas").hide();
          $(".content_block_Product_Specs_and_Care_Metal").show();
          console.log("change variant metal");

          //removing active class from canvas blocks
          $(
            ".general_faq .content_block_Product_Specs_and_Care_Canvas"
          ).removeClass("active");

          //adding active class to metal block
          $(
            ".general_faq .content_block_Product_Specs_and_Care_Metal"
          ).addClass("active");

          //size guide changes
          $("#canvas_guide").addClass("dissable");
          $("#canvas_guide").removeClass("ennable");
          $("#metal_guide").addClass("ennable");
          $("#metal_guide").removeClass("dissable");
          //btn
          $(".c_button[data-size='canvas_guide'").removeClass("active");
          $(".c_button[data-size='metal_guide'").addClass("active");
        }

        //next hiding unavialble variants
        setTimeout(function () {
          $(".fieldset_size input").each(function () {
            if ($(this).hasClass("disabled")) {
              $(this).hide(); // Hide the input
              console.log("hdiing");
              $(this).next("label").hide(); // Hide the label next to it
            } else {
              $(this).show();
              $(this).next("label").show(); // Hide the label next to it
            }
          });
        }, 10);
      });
    });

  //converting inch to cm and vice versa

  //first inch to cm
  $(document).on("click", "#cm_click", function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".size_conv").removeClass("active");
      $(this).addClass("active");
      var labels = $(".fieldset_size label");
      // labels.each(function () {
      //   // var originalText = $(this).find("span.fetch_text").text().trim();
      //   var originalText = $(this).attr("data-val").trim();
      //   // console.log("fetched text: " + originalText);
      //   var dimensions = originalText.split("x");

      //   // Convert dimensions to centimeters (assuming 1 inch = 2.54 cm)
      //   var cmWidth = parseFloat(dimensions[0]) * 2.54;
      //   var cmHeight = parseFloat(dimensions[1]) * 2.54;

      //   // Construct new label text with centimeters
      //   var newText =
      //     formatDimension1(cmWidth) + "x" + formatDimension1(cmHeight);
      //   // console.log("newText text: " + newText);
      //   // Update label text
      //   $(this).find("span.fetch_text").text(newText);
      // });

      labels.each(function () {
        var originalText = $(this).attr("data-val").trim().toLowerCase();
        var dimensions = originalText.split("x");

        let newText = "";

        // Helper: inches to rounded cm
        const toCm = (inches) => Math.round(parseFloat(inches) * 2.54);

        if (dimensions.length === 2) {
          // Format: WxH
          var width = parseFloat(dimensions[0]);
          var height = parseFloat(dimensions[1]);

          if (!isNaN(width) && !isNaN(height)) {
            newText = `${toCm(width)}x${toCm(height)}`;
          }
        } else if (dimensions.length === 1) {
          // Format: single number
          var value = parseFloat(dimensions[0]);

          if (!isNaN(value)) {
            newText = `${toCm(value)}`;
          }
        }

        if (newText) {
          $(this).find("span.fetch_text").text(newText);
        }
      });


    }
  });
  function formatDimension1(value) {
    var roundedValue;
    var decimalPart = value - Math.floor(value);

    if (decimalPart >= 0.7) {
      roundedValue = Math.ceil(value);
    } else {
      roundedValue = Math.floor(value);
    }

    return roundedValue;
  }
  $(document).on("click", "#inch_click", function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".size_conv").removeClass("active");
      $(this).addClass("active");
      var labels = $(".fieldset_size label");
      labels.each(function () {
        // var originalText = $(this).find("span.fetch_text").text().trim();
        var originalText = $(this).attr("data-val").trim();
        // console.log("Fetched text: " + originalText);
        // var dimensions = originalText.split('x');

        // // Convert dimensions from centimeters to inches
        // var inchWidth = parseFloat(dimensions[0]) / 2.54;
        // var inchHeight = parseFloat(dimensions[1]) / 2.54;

        // // Construct new label text with inches
        // var newText = formatDimension(inchWidth) + 'x' + formatDimension(inchHeight);
        // console.log("New text: " + newText);

        // // Update label text
        $(this).find("span.fetch_text").text(originalText);
      });
    }
  });

  function formatDimension(value) {
    var formattedValue = value.toFixed(1);
    if (formattedValue.endsWith(".0")) {
      return value.toFixed(0); // Remove decimal if it ends with '.0'
    } else {
      return formattedValue; // Otherwise, return with one decimal place
    }
  }

  //review section
  // $(".jdgm-carousel__item-wrapper .jdgm-carousel-item").each(function () {
  //   $(this).addClass("clipped_pattern");
  // });

  updateClipPath();

  //replacing review slider arrow
  var svgLeftContent = `
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 78.56 34">
        <defs>
            <style>
                .cls-1 { fill: none; }
                .cls-1, .cls-2, .cls-3 { stroke-width: 0px; }
                .cls-2 { fill: #450040; }
                .cls-3 { fill: #fff; }
            </style>
        </defs>
        <g>
            <path class="cls-1" d="M20.52,20.24h-.01M20.52,20.24h-.01"/>
            <path class="cls-2" d="M0,20.92l2.13,2.45,3.26,3.76.7.81,1.06-.13c1.6-.2,3.28-.3,4.98-.3,3.67,0,7.39.46,10.78,1.33,3.41.87,6.61,2.1,9.53,3.64l2.88,1.52,2-2,.05-3.26.05-2.77.02-1.12-.94-.6c-.41-.26-.82-.52-1.24-.76,13,.61,25.46,2.24,35.35,4.69l5.95,1.47,2-2-3.94-4.7-2.98-3.56-.42-.5-.64-.16c-9.02-2.23-18.64-3.66-29.22-4.34,2.18-1.38,4.34-2.88,6.47-4.49l1.69-1.27,2-2-1.36-1.61-2.98-3.56L45.96,0l-1.52,1.14c-7.09,5.34-14.42,9.41-21.78,12.1-4.49,1.64-9.24,2.82-13.83,3.96-1.23.3-2.46.61-3.69.92l-3.14.8L0,20.92Z"/>
        </g>
        <path class="cls-3" d="M35.42,25.94c-4.74-3.04-9.34-4.63-14.9-5.7.01,0,.01,0,0,0,0,0,2.03-1.01,5.05-1.02,14.9-.02,33.05,1.44,47.53,5.02l-2.98-3.56c-12.23-3.02-24.8-4.34-37.39-4.66,5.63-2.65,10.92-5.95,15.92-9.71l-2.99-3.56c-6.84,5.15-14.25,9.44-22.3,12.38-5.77,2.11-11.76,3.42-17.71,4.94l3.27,3.76c5.37-.66,11.28-.26,16.51,1.08,3.45.89,6.81,2.14,9.96,3.81l.05-2.77Z"/>
        <path class="cls-1" d="M18.51,22.24h.01"/>
    </svg>`;

  // Inject the SVG content into the desired element
  $(".jdgm-carousel__left-arrow").html(svgLeftContent);

  var svgRightContent = `
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 78.56 34">
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }

          .cls-1, .cls-2, .cls-3 {
            stroke-width: 0px;
          }

          .cls-2 {
            fill: #450040;
          }

          .cls-3 {
            fill: #fff;
          }
        </style>
      </defs>
      <g>
        <path class="cls-1" d="M58.05,20.24h-.01M58.05,20.24h-.01"/>
        <path class="cls-2" d="M78.56,20.92l-2.13,2.45-3.26,3.76-.7.81-1.06-.13c-1.6-.2-3.28-.3-4.98-.3-3.67,0-7.39.46-10.78,1.33-3.41.87-6.61,2.1-9.53,3.64l-2.88,1.52-2-2-.05-3.26-.05-2.77-.02-1.12.94-.6c.41-.26.82-.52,1.24-.76-13,.61-25.46,2.24-35.35,4.69l-5.95,1.47-2-2,3.94-4.7,2.98-3.56.42-.5.64-.16c9.02-2.23,18.64-3.66,29.22-4.34-2.18-1.38-4.34-2.88-6.47-4.49l-1.69-1.27-2-2,1.36-1.61,2.98-3.56,1.22-1.46,1.52,1.14c7.09,5.34,14.42,9.41,21.78,12.1,4.49,1.64,9.24,2.82,13.83,3.96,1.23.3,2.46.61,3.69.92l3.14.8,2,2Z"/>
      </g>
      <path class="cls-3" d="M43.14,25.94c4.74-3.04,9.34-4.63,14.9-5.7-.01,0-.01,0,0,0,0,0-2.03-1.01-5.05-1.02-14.9-.02-33.05,1.44-47.53,5.02l2.98-3.56c12.23-3.02,24.8-4.34,37.39-4.66-5.63-2.65-10.92-5.95-15.92-9.71l2.99-3.56c6.84,5.15,14.25,9.44,22.3,12.38,5.77,2.11,11.76,3.42,17.71,4.94l-3.27,3.76c-5.37-.66-11.28-.26-16.51,1.08-3.45.89-6.81,2.14-9.96,3.81l-.05-2.77Z"/>
      <path class="cls-1" d="M60.04,22.23h0s0,.01.01.01"/>
    </svg>`;

  // Inject the SVG content into the desired element
  $(".jdgm-carousel__right-arrow").html(svgRightContent);

  var svgStarContent = `
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 45.99 45.92">
    <defs>
      <style>
        .cls-1 {
          fill: #450040;
        }

        .cls-1, .cls-2 {
          stroke-width: 0px;
        }

        .cls-2 {
          fill: #deff00;
        }
      </style>
    </defs>
    <path class="cls-1" d="M45.99,15.31l-2.78,3.29-3.08,3.65-.48.57-.74.12c-2.56.4-5.11,1.24-7.92,2.62.6,2.17,1.28,4.15,2.07,6.01.38.9.8,1.81,1.26,2.71l.61,1.19-.87,1.02-2.88,3.38-2.02,2.35-2-2-1.31-2.8-.78-1.64c-.5-1.08-1.03-1.98-1.61-2.77-.31-.41-.63-.81-.99-1.21-.2-.18-.4-.36-.61-.53-1.85,1.68-5.62,5.29-9.04,8.62l-6.2,6.03-2-2,2.92-8.14,2.13-5.93,1.67-4.68c-2.3-.99-4.58-1.83-6.63-2.55l-2.71-.95-2-2,1.84-2.21,2.86-3.43.6-.72h10.29l2.89-8.05.2-.56.47-.36,3.03-2.31,2.67-2.03,2,2,.52,3.31c.29,1.79.52,3.42.74,5,.15,1.01.28,1.99.43,3h15.45l2,2Z"/>
    <path class="cls-2" d="M19.81,26.68c2.01,1.49,3.8,3.18,5.25,5.14.72.97,1.31,2.02,1.82,3.1l.77,1.64,2.89-3.38c-.48-.93-.92-1.88-1.32-2.85-1.07-2.53-1.9-5.15-2.57-7.83,3.12-1.67,6.4-2.99,9.96-3.55l3.08-3.65h-14.53c-.73-4.28-1.1-7.49-1.76-11.69l-3.04,2.32-3.36,9.37H6.24s-2.86,3.43-2.86,3.43c3.44,1.21,7.22,2.64,10.79,4.48-1.58,4.41-3.16,8.83-4.74,13.24,0,0,9.32-9.07,10.38-9.77ZM20.85,9.18c.3,2.03.58,4.08.89,6.13h-3.08c.73-2.04,1.46-4.09,2.2-6.13ZM15.77,18.73c-.04.14-.08.34-.12.46-.26-.13-1.67-.46-2.02-.46h2.14ZM12.78,31.7c.92-2.58,1.84-5.16,2.77-7.74,1.12.62,2.21,1.29,3.26,2.01-2.17,1.67-4.26,3.59-6.03,5.74ZM22.67,23.24c-1.74-1.3-3.65-2.44-5.62-3.45.13-.35.25-.71.38-1.06h4.86c.24,1.41.51,2.83.81,4.23-.14.09-.28.18-.42.28ZM26.26,20.91c-.17-.72-.32-1.45-.47-2.18h4.33c-1.32.67-2.6,1.4-3.86,2.18Z"/>
  </svg>`;

  // Iterate over each .jdgm-star element within .jdgm-carousel-item__review-rating
  $(".jdgm-carousel-item__review-rating .jdgm-star").each(function () {
    // Inject the SVG content into each .jdgm-star element
    $(this).html(svgStarContent);
  });
  $(".jdgm-rev__rating .jdgm-star").each(function () {
    // Inject the SVG content into each .jdgm-star element
    $(this).html(svgStarContent);
  });

  //removed clipped_pattern class from size guide modal on product page
  function handleResize() {
    if ($(window).width() < 749) {
      $(".moadl_inner").removeClass("clipped_pattern");
      $(".moadl_inner").find("img").removeClass("clipped_pattern");
      $(".moadl_inner").find("img.no_patter").removeClass("clipped_pattern");
    } else {
      $(".moadl_inner").addClass("clipped_pattern");
      $(".moadl_inner").find("img").addClass("clipped_pattern");
      $(".moadl_inner").find("img.no_patter").removeClass("clipped_pattern");
    }

    // $(".jdgm-rev-widg__reviews .jdgm-rev").addClass("clipped_pattern");
  }

  // Initial check
  handleResize();

  // Handle screen resizing
  $(window).resize(function () {
    handleResize();
  });

  ///////////////// PRODUCT PAGE /////////////////

  //collection page - show product which got clicked last
  // Function to get the collection name from the URL

  // initialize();

  // $(window).on('pageshow', function () {
  //   console.log("Page show");
  //     initialize();
  // });
  // Function to check if current collection matches stored collection
  function initialize() {
    if (window.location.pathname.includes("/collections/")) {
      checkCurrentCollection();
      console.log("run from collection page");
    } else if (window.location.pathname.includes("/products/")) {
      console.log("productPage");
    } else {
      localStorage.removeItem("currentCollection");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("currentPrdScrollID");
    }
  }
  $(document).on("click", ".scroll_id_save_click", function () {
    // $('.scroll_id_save_click').on('click', function() {
    if (window.location.pathname.includes("/collections/")) {
      var scroll_id = $(this).attr("data-scroll-id");
      console.log("cliekc product");
      localStorage.setItem("currentPrdScrollID", scroll_id);
    }
  });

  if(!window.location.pathname.includes("/collections/") && !window.location.pathname.includes("/products/")){
    localStorage.removeItem("currentPrdScrollID");
  }

  //product page////
  let scrollCallCount = 0; // Counter for the number of calls
  const maxScrollCalls = 2; // Maximum number of calls allowed
  const intervalTime = 100; // Time interval between calls in milliseconds
  function initCarousel() {
    if (window.innerWidth < 767) {
      // Swap classes for arrows
      $(".jdgm-carousel__left-arrow")
        .addClass("review_left_Arrow")
        .removeClass("jdgm-carousel__left-arrow");
      $(".jdgm-carousel__right-arrow")
        .addClass("review_right_Arrow")
        .removeClass("jdgm-carousel__right-arrow");

      // $('.jdgm-carousel-item').addClass('custom_carousel_item').removeClass('jdgm-carousel-item');

      $(".jdgm-carousel__item-wrapper").slick({
        infinite: true,
        dots: false,
        fade: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $(".review_left_Arrow"),
        nextArrow: $(".review_right_Arrow"),
        autoplaySpeed: 4000,
        draggable: true,
        speed: 400,
        adaptiveHeight: true,
      });

      // // Recalculate height on window resize
      // $(window).on('scroll', function() {
      //   $('.jdgm-carousel__item-wrapper').slick('setPosition');
      // });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Call setPosition when the element comes into view
            if (scrollCallCount < maxScrollCalls) {
              const intervalId = setInterval(() => {
                if (scrollCallCount < maxScrollCalls) {
                  $(".jdgm-carousel__item-wrapper").slick("setPosition");
                  scrollCallCount++;
                  console.log("scrollCallCount: " + scrollCallCount);
                } else {
                  clearInterval(intervalId); // Stop the interval when max calls reached
                }
              }, intervalTime);
            }

            // Optional: unobserve the entry if you want to stop observing after the first trigger
            // observer.unobserve(entry.target);
          }
        });
      });

      // Start observing the jdgm-carousel__item-wrapper element
      const carouselElement = document.querySelector(
        ".jdgm-carousel__item-wrapper"
      );
      if (carouselElement) {
        observer.observe(carouselElement);
      }
    } else {
      if ($(".jdgm-carousel__item-wrapper").hasClass("slick-initialized")) {
        $(".jdgm-carousel__item-wrapper").slick("unslick");
      }
      // Reverse class swapping for arrows
      $(".review_left_Arrow")
        .addClass("jdgm-carousel__left-arrow")
        .removeClass("review_left_Arrow");
      $(".review_right_Arrow")
        .addClass("jdgm-carousel__right-arrow")
        .removeClass("review_right_Arrow");

      // $('.custom_carousel_item').addClass('jdgm-carousel-item').removeClass('custom_carousel_item');
    }
  }

  // $('.jdgm-carousel__item-wrapper').css("opacity", "0");
  // Event delegation for right arrow click
  $(document).on("click", ".review_right_Arrow", function () {
    $(".jdgm-carousel__item-wrapper").slick("slickNext"); // Move to the next slide
  });
  $(".review_right_Arrow").trigger("click"); // Simulate right arrow click
  // Simulate left arrow click
  // // Event delegation for left arrow click
  // $(document).on('click', '.review_left_Arrow', function() {
  //   $('.jdgm-carousel__item-wrapper').slick('slickPrev'); // Move to the previous slide
  // });
  // $('.jdgm-carousel__item-wrapper').css("opacity", "1");

  // Run on page load
  initCarousel();

  // Run on window resize
  $(window).resize(function () {
    initCarousel();
  });
  //product page////

  //////////////  CODE FOR CUSTOM PRINTS  //////////////
  let cropper;
  let currentZoom = 1; // Initial zoom level
  let secondaryCropper, secondaryCropBoxData; // To hold the secondary cropper reference
  let fileExtension;

  // Function to create a delay
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  //description area for cropper border
  // Check if session exists and its expiry time
  let hideUntil = sessionStorage.getItem("hideUntil");
  let currentTime = new Date().getTime();

  // If session is not set or expired, show the absolute_content element
  if (!hideUntil || currentTime > hideUntil) {
    $(".absolute_content").addClass("show").removeClass("hide");
  } else {
    $(".absolute_content").addClass("hide").removeClass("show");
  }

  // When close_border_desc is clicked
  $("#close_border_desc").on("click", function () {
    // Add hide class to absolute_content and remove show class
    $(".absolute_content").addClass("hide").removeClass("show");

    // Set session expiration for 8 hours
    let expirationTime = currentTime + 30 * 60 * 1000; // 30mins in milliseconds
    // let expirationTime = currentTime + (60 * 1000); // 8 hours in milliseconds
    sessionStorage.setItem("hideUntil", expirationTime);
  });

  //initiaint click event on original select input with fake custom drop file button
  $("#change_on_select").on("click", function () {
    $("#customer_photo").click();
  });

  // Define the aspect ratio based on the title
  var aspectRatio = 1 / 1;
  var imageWidth, imageHeight; //var for dimensions of the cropped canvas
  var minRequiredWidth, minRequiredHeight; //var for minimum required image dimensions
  var flagToChecDimesnionComparision = false; //var this will used to only run dimesnion comparision when image is uploaded

  $("#del-btn").on("click", function () {
    $("#customer_photo").val(""); // Clear the file input
    console.log("delete icon clicked");
    $("#open-editor").prop("disabled", true);
    $("#del-btn").css("opacity", "0"); // Disabling the "Delete" button
    $("#del-btn").css("visibility", "hidden"); // Disabling the "Delete" button
    //removing active class form custom dropbox for image
    $("#change_on_select").removeClass("active");
    $("#show-on-sel").html(""); //resetting value of image name element to empty
    $(".btn_block").removeClass("active"); //hiding add to cart button when image is unselected
    flagToChecDimesnionComparision = false; //variable to make size comparision in-active on variant change

    //hiding warning by simply removing the class, if it exists
    $("#preview-warning").removeClass("active");

    //RESETTING IMG IN THE IMAGE AREA
    // Select the last <li> in the <ul> inside <slider-component>
    $("slider-component").each(function () {
      // Select the last <li> in the <ul> within the current slider-component
      var $lastLi = $(this).find("ul li:last");

      // Find the element with class last_layout_inner inside the last <li>
      var $lastLayoutInner = $lastLi.find(".last_layout_inner");

      // Get data-img value from the img element
      var $img = $lastLayoutInner.find("img");

      var imgSrc = $img.data("img");
      console.log("Image source:", imgSrc); // Check the value of imgSrc

      // Check if imgSrc is found
      if (imgSrc) {
        // Set the src attribute of the img element
        $img.attr("src", imgSrc);

        // Get data-img value from the bdrImg element
        var bdrImgSrc = $lastLayoutInner.find(".bdrImg").data("img");
        console.log("Background Image Source:", bdrImgSrc); // Check the value of bdrImgSrc

        // Set the background image of the bdrImg element
        $lastLayoutInner
          .find(".bdrImg")
          .css("background-image", "url('" + bdrImgSrc + "')");
      } else {
        console.error("No data-img found on the image.");
      }
    });
    //RESETTING IMG IN THE IMAGE AREA
  });

  //when the warning checkbox is clicked
  $("#confirm_photo").change(function () {
    if ($(this).is(":checked")) {
      $(".btn_block").addClass("active");
    } else {
      $(".btn_block").removeClass("active");
    }
  });

  var redBlueCropperGap;
  if ($("#image-editor-modal").length > 0) {
    var aspectRatio;

    //zoom slider changing color
    const slider = document.getElementById("zoom-slider");

    slider.addEventListener("input", function () {
      const value = ((this.value - this.min) / (this.max - this.min)) * 100; // Calculate percentage
      this.style.setProperty("--value", value + "%"); // Set custom property for background
    });

    var title = $(".title_custom_print").data("title").toLowerCase(); // Convert to lowercase for easy comparison
    if (title.includes("square")) {
      aspectRatio = 1 / 1; // Square
    } else if (title.includes("portrait")) {
      aspectRatio = 2 / 3; // Portrait
    } else if (title.includes("landscape")) {
      aspectRatio = 3 / 2; // Landscape
    } else if (title.includes("sherpa blanket")) {
      aspectRatio = 5 / 6; // Default to square if no match
    }

    if (title.includes("canvas")) {
      // redBlueCropperGap = 25;
      redBlueCropperGap = 2;
    } else {
      redBlueCropperGap = 2;
    }
    console.log("GAP: ", redBlueCropperGap);

    //CODE FOR CHECKING --- selected print size[minimum dimension for crop] and cropped dimension
    //This will happen when image is saved
    //following function will run when value of Frame Colour option is changed
    document
      .querySelectorAll('input[name^="Size"]')
      .forEach(function (selectElement) {
        selectElement.addEventListener("change", function (selectElement) {
          console.log("Variant optionss changed:", selectElement.target.value);
          //run code only when image is uploaded
          if (flagToChecDimesnionComparision) {
            document
              .querySelectorAll('input[name^="Size"]')
              .forEach(function (selectElement) {
                if (selectElement.checked) {
                  const sizeValue = selectElement.value; // E.g., '36x24'
                  [widthInInches, heightInInches] = sizeValue
                    .split("x")
                    .map(Number); // Split and convert to numbers
                }
              });

            // Ensure that width and height are numbers
            if (!widthInInches || !heightInInches) {
              console.error("Please ensure a valid size is selected.");
              return;
            } else {
              console.log("Width: " + widthInInches);
              console.log("Height: " + heightInInches);
            }

            // Get the dimensions of the cropped canvas
            imageWidth = fullQualityCanvas.width;
            imageHeight = fullQualityCanvas.height;

            console.log("cropped imageWidth: " + imageWidth);
            console.log("cropped imageHeight: " + imageHeight);

            // Minimum PPI requirement
            const minimumPPI = 120;

            // Calculate the minimum required image dimensions based on the selected size and minimum PPI
            minRequiredWidth = widthInInches * minimumPPI;
            minRequiredHeight = heightInInches * minimumPPI;

            console.log(
              "Minimum Required Width[after multiplying selected canvas width & minimum ppd]: " +
                minRequiredWidth
            );
            console.log(
              "Minimum Required Height[after multiplying selected canvas height & with minimum ppd]: " +
                minRequiredHeight
            );

            // Set the data attributes for the minimum required width and height
            const uploadedSizeElement = document.getElementById(
              "current_uploaded_size"
            );
            uploadedSizeElement.setAttribute("data-width", minRequiredWidth);
            uploadedSizeElement.setAttribute("data-height", minRequiredHeight);

            // Check if the image dimensions meet the minimum requirement
            // Get the element to display warnings
            const warningsElement = document.getElementById("upload_warnings");
            warningsElement.innerHTML = ""; // Clear previous warnings

            if (
              imageWidth < minRequiredWidth ||
              imageHeight < minRequiredHeight
            ) {
              try {
                // Call the imageUpload function and wait for it to finish
                console.log(
                  "handleImageUpload in if - before imageUpload call"
                );
                console.log("handleImageUpload in if - After imageUpload call");

                // If `showCheckbox` becomes true after the upload
                showCheckbox = true;
                if (showCheckbox) {
                  const warningMessage = `The uploaded image does not meet the minimum resolution requirement of ${minimumPPI} PPI. <br>Required: ${minRequiredWidth}px (width) x ${minRequiredHeight}px (height). <br>Uploaded: ${imageWidth}px (width) x ${imageHeight}px (height).`;

                  console.warn(warningMessage);

                  // Create and append a warning message
                  const warningElement = document.createElement("p");
                  warningElement.innerHTML = warningMessage; // Use innerHTML to inject the HTML content
                  warningElement.classList.add("warning_p");
                  warningsElement.appendChild(warningElement);

                  //show new warning
                  ///HIDING WARNINGS FOR SOMETIME
                  // $("#preview-warning").addClass("active");
                  ///HIDING WARNINGS FOR SOMETIME
                  ///HIDING BUUTON DISABLE FEATURE FOR SOMETIME
                  // $(".btn_block").removeClass("active"); //hiding add to cart button when image is unselected
                  ///HIDING BUUTON DISABLE FEATURE FOR SOMETIME
                  //makeing warning checkbox uncheck

                  //v3.1- Commenting to test - if it disable the functionality where changing size option disabling add to cart
                  // $(".btn_block").addClass("active"); //showing button for sometime
                  // $("#confirm_photo").prop("checked", false);
                  // //making buy button disable
                  // $(".btn_block").removeClass("active");
                  //v3.1- Commenting to test - if it disable the functionality where changing size option disabling add to cart

                  // Reset `showCheckbox` after displaying the message
                  showCheckbox = false;
                } else {
                  console.log(
                    "Image doesn't match minimum requirements, but no warnings were triggered."
                  );
                  //show new warning
                  $("#preview-warning").removeClass("active");
                }
              } catch (error) {
                // Catch any errors that occur during imageUpload
                console.error("Error during image upload:", error);
              }
            } else {
              // If the image meets the minimum requirements, just proceed with the upload
              //hide the warning if its there
              showCheckbox = false;
              $("#preview-warning").removeClass("active");
              //making buy button enable
              $(".btn_block").addClass("active");
              try {
                // Call the imageUpload function and wait for it to complete
                console.log(
                  "handleImageUpload in else - before imageUpload call"
                );
                console.log(
                  "handleImageUpload in else - after imageUpload call"
                );
              } catch (error) {
                console.error("Error during image upload:", error);
              }
            }
          } else {
            console.log("image is not there");
          }
        });
      });
    //CODE FOR CHECKING --- selected print size[minimum dimension for crop] and cropped dimension

    function createSecondaryCropper() {
      // Create the secondary cropper div only once
      if (!secondaryCropper) {
        console.log("-secondary not exist");
        secondaryCropper = $('<div class="secondary-cropper"></div>').css({
          position: "absolute",
          border: "1px solid red", // Style the secondary cropper
          pointerEvents: "none", // Prevent interaction with the secondary cropper
          display: "block", // Ensure the secondary cropper is visible
        });

        // Append it to the crop box container
        $(".cropper-crop-box").append(secondaryCropper);
      } else {
        console.log("-secondary exist");
        console.log("-secondary not exist");
        secondaryCropper = $('<div class="secondary-cropper"></div>').css({
          position: "absolute",
          border: "1px solid red", // Style the secondary cropper
          pointerEvents: "none", // Prevent interaction with the secondary cropper
          display: "block", // Ensure the secondary cropper is visible
        });

        // Append it to the crop box container
        $(".cropper-crop-box").append(secondaryCropper);
      }
    }

    function drawSecondaryCropper() {
      if (secondaryCropper) {
        console.log("in 1drawSecondaryCropper");
        const cropBoxData = cropper.getCropBoxData();
        const newGap = (100 - redBlueCropperGap) / 100;
        console.log("New GAP: ", newGap);

        // const newWidth = cropBoxData.width * 0.75; // 25% smaller
        // const newHeight = cropBoxData.height * 0.75; // 25% smaller
        const newWidth = cropBoxData.width * newGap; // 25% smaller
        const newHeight = cropBoxData.height * newGap; // 25% smaller
        // const left = cropBoxData.left + (cropBoxData.width - newWidth) / 2; // Center horizontally
        // const top = cropBoxData.top + (cropBoxData.height - newHeight) / 2; // Center vertically
        const left = (cropBoxData.width - newWidth) / 2; // Center horizontally
        const top = (cropBoxData.height - newHeight) / 2; // Center vertically
        console.log(
          "main left: " +
            cropBoxData.left +
            ", main top: " +
            cropBoxData.top +
            "\nSecondary left: " +
            left +
            ", Secondary top: " +
            top +
            "\n\n"
        );

        secondaryCropper.css({
          width: newWidth + "px",
          height: newHeight + "px",
          left: left + "px",
          top: top + "px",
          display: "block", // Ensure it's displayed
        });

        secondaryCropBoxData = {
          left: parseFloat(secondaryCropper.css("left")),
          top: parseFloat(secondaryCropper.css("top")),
          width: parseFloat(secondaryCropper.css("width")),
          height: parseFloat(secondaryCropper.css("height")),
        };

        // //hide loader
        // alert("hide loader");
      }
    }

    //function which will execute when either phtoo/image is selected or redit image button is clicked
    // Function to initialize the image editor and Cropper.js
    function initializeImageEditor(file) {
      const reader = new FileReader();

      // Get the file extension
      fileExtension = file.name.split(".").pop().toLowerCase();
      console.log("File extension:", fileExtension);

      reader.onload = function (event) {
        const image = document.getElementById("image-preview");
        image.src = event.target.result;

        // Open the modal for image editing
        $("body").addClass("overflow_hidden");
        $("#image-editor-modal").fadeIn();
        $("#loader-modal").fadeOut();
        // $("#image-editor-modal").addClass("modal_show");
        // $("#loader-modal").fadeOut(150, function() {
        //   $("#image-editor-modal").fadeIn();
        // });
        // document.getElementById('loader-modal').style.display = 'none'; // Hide the modal

        // Destroy the previous cropper if it exists
        if (cropper) {
          cropper.destroy(); // Destroy previous cropper instance
          cropper = null; // Reset the cropper variable
        }

        // Initialize Cropper.js for the selected image
        cropper = new Cropper(image, {
          aspectRatio: aspectRatio, // Customize aspect ratio as needed
          viewMode: 1,
          dragMode: "move", // Enable dragging the image
          zoomable: true,
          zoomOnWheel: true,
          movable: true,
          modal: true,
          center: true,
          crop(event) {
            // Crop event
          },
          ready: function () {
            console.log("!!ready cropper!!!");
            createSecondaryCropper(); // Create the secondary cropper
            drawSecondaryCropper(); // Initial draw
          },
          cropmove(event) {
            drawSecondaryCropper(); // Redraw secondary cropper on crop move
          },
          cropend(event) {
            drawSecondaryCropper(); // Redraw secondary cropper on crop end
          },
        });
      };

      // Read the file as DataURL
      reader.readAsDataURL(file);
    }

    // document.getElementById('customer_photo').addEventListener('change', function(event) {
    //   const reader = new FileReader();

    //   //getting file extension
    //   const file = event.target.files[0]; // Get the selected file
    //   fileExtension = file.name.split('.').pop().toLowerCase(); // Get the extension and convert it to lowercase
    //   console.log("File extension:", fileExtension); // Log the file extension

    //   reader.onload = function(event) {
    //       const image = document.getElementById('image-preview');
    //       image.src = event.target.result;

    //       // Open the modal for image editing
    //       // document.getElementById('image-editor-modal').style.display = 'block';
    //       $("body").addClass("overflow_hidden");
    //       $("#image-editor-modal").fadeIn();

    //       // Initialize Cropper.js for the selected image
    //       cropper = new Cropper(image, {
    //           aspectRatio: aspectRatio, // Customize aspect ratio as needed
    //           viewMode: 2,
    //           // dragMode: 'move',
    //           zoomable: true,
    //           zoomOnWheel: false,
    //           movable: true,
    //           modal: true,
    //           center: true,
    //           crop(event) {
    //             // Crop event
    //           },
    //           ready: function() {
    //             createSecondaryCropper(); // Create the secondary cropper
    //             drawSecondaryCropper(); // Initial draw
    //           },
    //           cropmove(event) {
    //               drawSecondaryCropper(); // Redraw secondary cropper on crop move
    //           },
    //           cropend(event) {
    //               drawSecondaryCropper(); // Redraw secondary cropper on crop end
    //           }
    //       });
    //   };

    //   // Read the selected file as DataURL
    //   reader.readAsDataURL(event.target.files[0]);
    // });

    // Disable the "Edit Image" button initially
    document.getElementById("open-editor").disabled = true;

    //adding clipped pattern to cropper
    // $(".imageee").addClass("clipped_pattern");
    // updateClipPath();

    // Event listener for file upload
    document
      .getElementById("customer_photo")
      .addEventListener("change", async function (event) {
        //setting background colr of modal
        $("#image-editor-modal").css("background", "rgba(55, 0, 60, .7)");
        console.log("change in image input for custom prints");
        const file = event.target.files[0]; // Get the selected file
        const editButton = document.getElementById("open-editor"); // Get the Edit Image button
        //show loader
        $("body").addClass("overflow_hidden");
        document.getElementById("loader-modal").style.display = "block";
        // $("#loader-modal").css("visibility", "visible");
        // $("#loader-modal").css("opacity", "1");

        //checking file uploaded size and extension
        const maxSizeInMB = 150; // Maximum size in MB
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
        const errorElement = document.getElementById("upload_error");

        errorElement.textContent = ""; // Clear previous error messages

        if (file) {
          // Check file type
          const allowedTypes = ["image/jpeg", "image/png"];
          if (!allowedTypes.includes(file.type)) {
            errorElement.textContent =
              "Please upload a valid JPG or PNG image.";
            event.target.value = ""; // Clear the input
            $("body").removeClass("overflow_hidden");
            $("#loader-modal").fadeOut();
            return; // Exit the function
          }

          // Check file size
          if (file.size > maxSizeInBytes) {
            errorElement.textContent =
              "File size exceeds 10 MB. Please upload a smaller file.";
            event.target.value = ""; // Clear the input
            $("body").removeClass("overflow_hidden");
            $("#loader-modal").fadeOut();
            return; // Exit the function
          }

          // If both checks pass, you can proceed with the image upload
          console.log("File is valid:", file);
          initializeImageEditor(file); // Call the function
          editButton.disabled = false; // Enable the "Edit Image" button
          $("#del-btn").css("opacity", "1"); // Enable the "Delete" button
          $("#del-btn").css("visibility", "visible"); // Enable the "Delete" button
          //setting file name to the p tage in custom select button
          // Get the selected file name
          var fileName = $(this).val().split("\\").pop(); // Extract just the file name
          // Set the file name to the element with id show-on-sel
          $("#show-on-sel").text(fileName);
          $("#change_on_select").addClass("active");
        } else {
          editButton.disabled = true; // Disable the "Edit Image" button if no file selected
          $("#del-btn").css("opacity", "0"); // Disabling the "Delete" button
          $("#del-btn").css("visibility", "hidden"); // Disabling the "Delete" button
        }
        //checking file uploaded size and extension

        //BEFORE RUNNING
        // if (file) {
        //     initializeImageEditor(file); // Call the function
        //     editButton.disabled = false; // Enable the "Edit Image" button
        // } else {
        //     editButton.disabled = true; // Disable the "Edit Image" button if no file selected
        // }
      });

    // Event listener for "Edit Image" button click
    document
      .getElementById("open-editor")
      .addEventListener("click", function () {
        $("#image-editor-modal").css("background", "rgba(55, 0, 60, .7)");
        const fileInput = document.getElementById("customer_photo");
        const file = fileInput.files[0]; // Check if a file has been selected

        if (file) {
          initializeImageEditor(file); // Call the function
        } else {
          alert("Please upload an image first before editing.");
        }
      });

    // Zoom slider
    // const zoomSlider = document.getElementById('zoom-slider');
    // zoomSlider.addEventListener('input', function () {
    //     // console.log("zoom changed");
    //     const zoomValue = parseFloat(this.value);

    //     // console.log("zoomValue: "+ zoomValue);
    //     // Calculate the zoom difference
    //     const zoomDifference = zoomValue - currentZoom;
    //     // console.log("zoomDifference: "+ zoomDifference);
    //     // Apply the zoom change
    //     cropper.zoom(zoomDifference);

    //     // Update the current zoom level
    //     currentZoom = zoomValue;
    // });

    // Initialize currentZoom to match the slider's initial value
    // let currentZoom = 0; // Start at 100%

    // // Zoom slider
    // const zoomSlider = document.getElementById('zoom-slider');
    // zoomSlider.addEventListener('input', function () {
    //     const zoomValue = parseFloat(this.value);
    //     console.log("zoom value: " + zoomValue + " ssss");

    //     // Apply the zoom directly using zoomTo
    //     cropper.zoomTo(zoomValue);

    //     // Update currentZoom to the new value
    //     currentZoom = zoomValue; // Update currentZoom to the new value
    // });
    let currentZoom = 0; // Start at 0.0

    // Zoom slider
    const zoomSlider = document.getElementById("zoom-slider");
    zoomSlider.addEventListener("input", function () {
      const zoomValue = parseFloat(this.value);
      // console.log("zoom value: " + zoomValue + " ssss");

      // Check if the zoom value is less than the minimum required
      if (zoomValue >= 0.1) {
        // Apply the zoom directly using zoomTo
        cropper.zoomTo(zoomValue);

        // Update currentZoom to the new value
        currentZoom = zoomValue; // Update currentZoom to the new value
      }
    });

    // Optional: Update the zoom level when the cropper is ready or zoomed programmatically
    // cropper.on('zoom', function (e) {
    //     // Ensure the slider reflects the current zoom level
    //     const newZoomLevel = e.detail.ratio; // Get the current zoom level from the event
    //     currentZoom = newZoomLevel; // Update currentZoom
    //     zoomSlider.value = newZoomLevel; // Synchronize the slider
    // });

    // Rotate button
    document
      .getElementById("rotate-btn-left")
      .addEventListener("click", function () {
        cropper.rotate(-90); // Rotate the image by 90 degrees
      });
    document
      .getElementById("rotate-btn-right")
      .addEventListener("click", function () {
        cropper.rotate(90); // Rotate the image by 90 degrees
      });

    document
      .getElementById("crop-reset-btn")
      .addEventListener("click", function () {
        cropper.reset(); // Reset cropper
        currentZoom = 0; // Reset the zoom level to its initial value
        zoomSlider.value = 0; // Set the zoom slider back to 0 (initial zoom level)
        drawSecondaryCropper(); // Update secondary cropper after reset
        // updateSecondaryCropper(); // Update secondary cropper after reset
      });

    //defining variable for full quality canvas that will be used in saving and uploading image
    let fullQualityCanvas;

    // Function to compress and store the image in a separate input
    const compressAndStoreImage = () => {
      // Set a maximum file size in bytes (5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      let quality = 1.0; // Start with maximum quality

      //step N1: Setting full qulaity canvas from cropper that will be used to upload the image
      fullQualityCanvas = cropper.getCroppedCanvas(); // Get the full-quality cropped canvas

      //step N2: storing full quality image from the cropper to local or session storage
      //that will beused if the upload stops abruptly

      // Step 1: Get the cropped canvas of the entire Cropper.js crop box
      const fullCroppedCanvas = cropper.getCroppedCanvas();

      // Step 2: Create a new canvas to represent the secondary crop area
      const secondaryCanvas = document.createElement("canvas");
      const secondaryContext = secondaryCanvas.getContext("2d");

      // Set the canvas size to the secondaryCropBox dimensions
      secondaryCanvas.width = secondaryCropBoxData.width;
      secondaryCanvas.height = secondaryCropBoxData.height;

      // Get crop box data and image data for accurate scaling
      const cropBoxData = cropper.getCropBoxData();
      const imageData = cropper.getImageData();

      // Calculate the scaling between the crop box and the actual canvas image
      const scaleX = fullCroppedCanvas.width / cropBoxData.width; // Scale factor for X
      const scaleY = fullCroppedCanvas.height / cropBoxData.height; // Scale factor for Y

      // Now calculate the position of the secondary crop box relative to the original image
      const secondaryLeft = secondaryCropBoxData.left * scaleX;
      const secondaryTop = secondaryCropBoxData.top * scaleY;

      // Step 3: Draw the secondary crop area on the new canvas
      secondaryContext.drawImage(
        fullCroppedCanvas,
        secondaryLeft,
        secondaryTop, // Start cropping at the position relative to the cropped image
        secondaryCropBoxData.width * scaleX,
        secondaryCropBoxData.height * scaleY, // Width and height of the crop area (scaled)
        0,
        0, // Start drawing on the new canvas at 0,0
        secondaryCropBoxData.width,
        secondaryCropBoxData.height // Size of the new canvas
      );

      secondaryCanvas.toBlob(
        function (blob) {
          // canvas.toBlob(function (blob) {
          // Check if the blob size exceeds the maximum size
          if (blob.size > maxSize && quality > 0) {
            // Reduce quality and try again
            quality -= 0.1; // Decrease quality by 10%
            compressAndStoreImage(); // Recursively call for compression
          } else {
            // Create a new File object from the Blob
            const file = new File([blob], "cropped-image-compressed.jpg", {
              type: "image/jpeg",
            });

            // Create a DataTransfer object to simulate file input
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);

            // Set the files property of the input to the new File
            const fileInput = document.getElementById("custom_photo"); // Make sure this ID matches your input
            fileInput.files = dataTransfer.files;

            //now setting compressed image in last image of the product gallery
            // Convert the blob to a data URL
            const img_reader = new FileReader();
            img_reader.onload = function (e) {
              // Find the last li element with class 'custom_print' in both ul elements
              const lastLiElements = document.querySelectorAll(
                "ul li.custom_print:last-child"
              );

              // Loop through each last li element
              lastLiElements.forEach((lastLiElement) => {
                // Find the img tag within .last_layout in the current lastLiElement
                const imgElement =
                  lastLiElement.querySelector(".last_layout img");
                if (imgElement) {
                  // Set the src of the img to the data URL
                  imgElement.src = e.target.result; // data URL
                  // Find the sibling element with class 'bdrImg'
                  const bdrImgElement = imgElement.nextElementSibling; // Assuming bdrImg is the immediate sibling
                  if (
                    bdrImgElement &&
                    bdrImgElement.classList.contains("bdrImg")
                  ) {
                    // Set the background image of bdrImgElement to the same data URL
                    bdrImgElement.style.backgroundImage = `url(${e.target.result})`;
                  }
                }
              });
            };

            img_reader.readAsDataURL(blob); // Convert blob to data URL

            //BEFORE RUNNING!!!
            //Optionally, close the cropper modal
            // cropper.destroy(); // Destroy the Cropper instance
            // document.getElementById('image-editor-modal').style.display = 'none'; // Hide the modal
          }
        },
        "image/jpeg",
        quality
      ); // Pass the quality parameter to toBlob

      //test for setting border image
      const fullCroppedCanvasNew = cropper.getCroppedCanvas();

      //test for setting border image
    };

    // const compressAndStoreImageNew = () => {
    //   // Set a maximum file size in bytes (5MB)
    //   const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    //   let quality = 1.0; // Start with maximum quality

    //   //step N1: Setting full qulaity canvas from cropper that will be used to upload the image
    //   fullQualityCanvas = cropper.getCroppedCanvas(); // Get the full-quality cropped canvas

    //   //step N2: storing full quality image from the cropper to local or session storage
    //   //that will beused if the upload stops abruptly

    //   // Step 1: Get the cropped canvas of the entire Cropper.js crop box
    //   const fullCroppedCanvas = cropper.getCroppedCanvas();

    //   // Step 2: Create a new canvas to represent the secondary crop area
    //   const secondaryCanvas = document.createElement("canvas");
    //   const secondaryContext = secondaryCanvas.getContext("2d");

    //   // Set the canvas size to the secondaryCropBox dimensions
    //   secondaryCanvas.width = secondaryCropBoxData.width;
    //   secondaryCanvas.height = secondaryCropBoxData.height;

    //   // Get crop box data and image data for accurate scaling
    //   const cropBoxData = cropper.getCropBoxData();
    //   const imageData = cropper.getImageData();

    //   // Calculate the scaling between the crop box and the actual canvas image
    //   const scaleX = fullCroppedCanvas.width / cropBoxData.width; // Scale factor for X
    //   const scaleY = fullCroppedCanvas.height / cropBoxData.height; // Scale factor for Y

    //   // Now calculate the position of the secondary crop box relative to the original image
    //   const secondaryLeft = secondaryCropBoxData.left * scaleX;
    //   const secondaryTop = secondaryCropBoxData.top * scaleY;

    //   // Step 3: Draw the secondary crop area on the new canvas
    //   secondaryContext.drawImage(
    //     fullCroppedCanvas,
    //     secondaryLeft,
    //     secondaryTop, // Start cropping at the position relative to the cropped image
    //     secondaryCropBoxData.width * scaleX,
    //     secondaryCropBoxData.height * scaleY, // Width and height of the crop area (scaled)
    //     0,
    //     0, // Start drawing on the new canvas at 0,0
    //     secondaryCropBoxData.width,
    //     secondaryCropBoxData.height // Size of the new canvas
    //   );

    //   secondaryCanvas.toBlob(
    //     function (blob) {
    //       // canvas.toBlob(function (blob) {
    //       // Check if the blob size exceeds the maximum size
    //       if (blob.size > maxSize && quality > 0) {
    //         // Reduce quality and try again
    //         quality -= 0.1; // Decrease quality by 10%
    //         compressAndStoreImage(); // Recursively call for compression
    //       } else {
    //         // Create a new File object from the Blob
    //         const file = new File([blob], "cropped-image-compressed.jpg", {
    //           type: "image/jpeg",
    //         });

    //         // Create a DataTransfer object to simulate file input
    //         const dataTransfer = new DataTransfer();
    //         dataTransfer.items.add(file);

    //         // Set the files property of the input to the new File
    //         const fileInput = document.getElementById("custom_photo"); // Make sure this ID matches your input
    //         fileInput.files = dataTransfer.files;

    //         // //now setting compressed image in last image of the product gallery
    //         // // Convert the blob to a data URL
    //         // const img_reader = new FileReader();
    //         // img_reader.onload = function (e) {
    //         //   // Find the last li element with class 'custom_print' in both ul elements
    //         //   const lastLiElements = document.querySelectorAll(
    //         //     "ul li.custom_print:last-child"
    //         //   );

    //         //   // Loop through each last li element
    //         //   lastLiElements.forEach((lastLiElement) => {
    //         //     // Find the img tag within .last_layout in the current lastLiElement
    //         //     const imgElement =
    //         //       lastLiElement.querySelector(".last_layout img");
    //         //     if (imgElement) {
    //         //       // Set the src of the img to the data URL
    //         //       imgElement.src = e.target.result; // data URL
    //         //       // Find the sibling element with class 'bdrImg'
    //         //       const bdrImgElement = imgElement.nextElementSibling; // Assuming bdrImg is the immediate sibling
    //         //       if (
    //         //         bdrImgElement &&
    //         //         bdrImgElement.classList.contains("bdrImg")
    //         //       ) {
    //         //         // Set the background image of bdrImgElement to the same data URL
    //         //         bdrImgElement.style.backgroundImage = `url(${e.target.result})`;
    //         //       }
    //         //     }
    //         //   });
    //         // };

    //         // img_reader.readAsDataURL(blob); // Convert blob to data URL

    //         //BEFORE RUNNING!!!
    //         //Optionally, close the cropper modal
    //         // cropper.destroy(); // Destroy the Cropper instance
    //         // document.getElementById('image-editor-modal').style.display = 'none'; // Hide the modal
    //       }
    //     },
    //     "image/jpeg",
    //     quality
    //   ); // Pass the quality parameter to toBlob

    //   //test for setting border image
    //   const fullCroppedCanvasNew = cropper.getCroppedCanvas();
    //   fullCroppedCanvasNew.toBlob(
    //     function (blob) {
    //       // canvas.toBlob(function (blob) {
    //       // Check if the blob size exceeds the maximum size
    //       if (blob.size > maxSize && quality > 0) {
    //         // Reduce quality and try again
    //         quality -= 0.1; // Decrease quality by 10%
    //         compressAndStoreImage(); // Recursively call for compression
    //       } else {
    //         // Create a new File object from the Blob
    //         const file = new File([blob], "cropped-image-compressed.jpg", {
    //           type: "image/jpeg",
    //         });

    //         // Create a DataTransfer object to simulate file input
    //         // const dataTransfer = new DataTransfer();
    //         // dataTransfer.items.add(file);

    //         // Set the files property of the input to the new File
    //         // const fileInput = document.getElementById("custom_photo"); // Make sure this ID matches your input
    //         // fileInput.files = dataTransfer.files;
    //         //now setting compressed image in last image of the product gallery
    //         // Convert the blob to a data URL
    //         const img_reader = new FileReader();
    //         img_reader.onload = function (e) {
    //           // Find the last li element with class 'custom_print' in both ul elements
    //           const lastLiElements = document.querySelectorAll(
    //             "ul li.custom_print:last-child"
    //           );

    //           // Loop through each last li element
    //           lastLiElements.forEach((lastLiElement) => {
    //             // Find the img tag within .last_layout in the current lastLiElement
    //             const imgElement =
    //               lastLiElement.querySelector(".last_layout img");
    //             if (imgElement) {
    //               // Set the src of the img to the data URL
    //               imgElement.src = e.target.result; // data URL
    //               // Find the sibling element with class 'bdrImg'
    //               const bdrImgElement = imgElement.nextElementSibling; // Assuming bdrImg is the immediate sibling
    //               if (
    //                 bdrImgElement &&
    //                 bdrImgElement.classList.contains("bdrImg")
    //               ) {
    //                 // Set the background image of bdrImgElement to the same data URL
    //                 bdrImgElement.style.backgroundImage = `url(${e.target.result})`;
    //               }
    //             }
    //           });
    //         };

    //         img_reader.readAsDataURL(blob); // Convert blob to data URL

    //         //BEFORE RUNNING!!!
    //         //Optionally, close the cropper modal
    //         // cropper.destroy(); // Destroy the Cropper instance
    //         // document.getElementById('image-editor-modal').style.display = 'none'; // Hide the modal
    //       }
    //     },
    //     "image/jpeg",
    //     quality
    //   );
    //   //test for setting border image
    // };

    //////  NEW downloadFullQualityImage CODE  ///////
    // Function to extract dimensions from input and calculate DPI
    const downloadFullQualityImage = async () => {
      // const fullQualityCanvas = cropper.getCroppedCanvas(); // Get the full-quality cropped canvas

      // Extract the selected size from input (in the format '36x24')
      let widthInInches = 0;
      let heightInInches = 0;

      document
        .querySelectorAll('input[name^="Size"]')
        .forEach(function (selectElement) {
          if (selectElement.checked) {
            const sizeValue = selectElement.value; // E.g., '36x24'
            [widthInInches, heightInInches] = sizeValue.split("x").map(Number); // Split and convert to numbers
          }
        });

      // Ensure that width and height are numbers
      if (!widthInInches || !heightInInches) {
        console.error("Please ensure a valid size is selected.");
        return;
      } else {
        console.log("Width: " + widthInInches);
        console.log("Height: " + heightInInches);
      }

      // Get the dimensions of the cropped canvas
      imageWidth = fullQualityCanvas.width;
      imageHeight = fullQualityCanvas.height;

      console.log("cropped imageWidth: " + imageWidth);
      console.log("cropped imageHeight: " + imageHeight);

      // Minimum PPI requirement
      const minimumPPI = 120;

      // Calculate the minimum required image dimensions based on the selected size and minimum PPI
      minRequiredWidth = widthInInches * minimumPPI;
      minRequiredHeight = heightInInches * minimumPPI;

      console.log(
        "Minimum Required Width[after multiplying selected canvas width & minimum ppd]: " +
          minRequiredWidth
      );
      console.log(
        "Minimum Required Height[after multiplying selected canvas height & with minimum ppd]: " +
          minRequiredHeight
      );

      // Set the data attributes for the minimum required width and height
      const uploadedSizeElement = document.getElementById(
        "current_uploaded_size"
      );
      uploadedSizeElement.setAttribute("data-width", minRequiredWidth);
      uploadedSizeElement.setAttribute("data-height", minRequiredHeight);

      // Check if the image dimensions meet the minimum requirement
      // Get the element to display warnings
      const warningsElement = document.getElementById("upload_warnings");
      warningsElement.innerHTML = ""; // Clear previous warnings

      //variable will be used to show checkbox afte rimage upload is done and modal is closed
      let showCheckbox = false;

      //function to upload image
      function imageUpload() {
        return new Promise((resolve, reject) => {
          // Clear all <p> tags (or any content) inside the #upload_warnings element
          warningsElement.innerHTML = "";

          // Calculate the PPI of uploaded image based on the selected size and canvas dimensions
          const dpiWidth = imageWidth / widthInInches;
          const dpiHeight = imageHeight / heightInInches;

          console.log(
            "Uploaded Image ppiWidth[after dividing cropped width with selected canvas width]: " +
              dpiWidth
          );
          console.log(
            "Uploaded Image ppiHeight[after dividing cropped height with selected canvas height]: " +
              dpiHeight
          );

          // Average DPI for the image
          const averageDPI = ((dpiWidth + dpiHeight) / 2).toFixed(2);
          const fileName = `cropped-image-${averageDPI}dpi.jpg`;
          var productId = $(".image-upload-field #productId").attr(
            "data-product-id"
          );

          console.log("product id: " + productId);

          $.ajax({
            type: "POST",
            url: "https://lxkvpq1145.execute-api.us-east-1.amazonaws.com/uvdesigns/sendParam", // Your API Gateway endpoint
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              productId: productId, // Sending productId as JSON
              imgExtension: fileExtension,
            }),
            beforeSend: function () {
              // Show loading overlay or spinner
              // $(".loading-overlay").css("display", "block");
              // $("html").css("overflow", "hidden");
              showCheckbox = false;
            },
            success: function (result) {
              console.log("Success in calling sendParams");
              var responseData = JSON.parse(result.body);
              var presignedUrl = responseData.presigned_url;
              var imageName = responseData.new_name;
              console.log("Uploaded Image Name: " + imageName);
              // Set the imageName to the input field with id 'custom_photo_name'
              document.getElementById("custom_photo_name").value = imageName;
              let blobExtension;

              if (fileExtension.toLowerCase() === "png") {
                blobExtension = "image/png";
              } else if (
                fileExtension.toLowerCase() === "jpg" ||
                fileExtension.toLowerCase() === "jpeg"
              ) {
                blobExtension = "image/jpeg";
              } else {
                blobExtension = "application/octet-stream";
              }

              // Download the image
              // fullQualityCanvas.toBlob((blob) => {
              //     const url = URL.createObjectURL(blob);
              //     const link = document.createElement('a');
              //     link.href = url;
              //     link.download = fileName;
              //     link.click();
              //     URL.revokeObjectURL(url);
              // }, blobExtension, 1);

              // console.log("Skipping Image uploaded to S3!");
              // resolve();
              //hide above two line when below commenet is un-commented
              // Upload the image to S3
              fullQualityCanvas.toBlob(
                (blob) => {
                  if (blob) {
                    $.ajax({
                      url: presignedUrl,
                      type: "PUT",
                      data: blob,
                      processData: false,
                      contentType: blob.type || "application/octet-stream",
                      // headers: {
                      //   "x-amz-tagging": "delete_after_30_days=true" 
                      // },
                      success: function () {
                        console.log("Image uploaded successfully!");
                        showCheckbox = true;
                        resolve(); // Resolve the promise after success
                        $(".btn_block").addClass("active"); //showing add to cart button when image uploads successfully
                        flagToChecDimesnionComparision = true; //variable to make size comparision active on variant change

                        //ALSO CHANGE THE CURRENT IMAGE, in the product gallery, to show uploaded or saved image
                        // Select the first slider component with the specific class
                        var $firstSlider = $(
                          ".slider-mobile-gutter.small-hide"
                        ).first();

                        // Find the <ul> within the first slider component
                        var $ul = $firstSlider.find("ul");

                        // Check if the <ul> has any <li> elements
                        if ($ul.length > 0) {
                          // Check if there are at least 2 <li> elements
                          if ($ul.find("li").length >= 2) {
                            // Find the button inside the second <li> and trigger a click
                            // var $buttonInSecondLi = $ul.find("li").eq(1).find("button");
                            var $buttonInSecondLi = $ul
                              .find("li")
                              .last()
                              .find("button");
                            if ($buttonInSecondLi.length) {
                              $buttonInSecondLi.trigger("click");
                            } else {
                              console.error(
                                "No button found in the second <li>."
                              );
                            }
                          } else {
                            console.error(
                              "Not enough <li> elements in the <ul> to trigger the button in the second <li>."
                            );
                          }
                        } else {
                          console.error(
                            "No <ul> found in the first slider component."
                          );
                        }
                        //ALSO CHANGE THE CURRENT IMAGE, in the product gallery, to show uploaded or saved image
                      },
                      error: function (xhr, status, error) {
                        console.error("Failed to upload image:", error);
                        reject(error); // Reject the promise in case of failure
                      },
                    });
                  } else {
                    console.error("Failed to create Blob from canvas.");
                    reject("Blob creation failed");
                  }
                },
                blobExtension,
                1
              );
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log("Fail:", textStatus, errorThrown);
              reject(`Error: ${textStatus} - ${errorThrown}`);
            },
            complete: function () {
              // $(".loading-overlay").css("display", "none");
              // $("html").css("overflow", "auto");
            },
          });
        });
      }

      async function handleImageUpload() {
        // Checking if the uploaded image meets the minimum width and height requirements
        if (imageWidth < minRequiredWidth || imageHeight < minRequiredHeight) {
          try {
            // Call the imageUpload function and wait for it to finish
            console.log("handleImageUpload in if - before imageUpload call");
            await imageUpload();
            console.log("handleImageUpload in if - After imageUpload call");

            cropper.destroy(); // Destroy the Cropper instance
            document.getElementById("image-editor-modal").style.display =
              "none"; // Hide the modal
            $("body").removeClass("overflow_hidden");

            // If `showCheckbox` becomes true after the upload
            if (showCheckbox) {
              const warningMessage = `The uploaded image does not meet the minimum resolution requirement of ${minimumPPI} PPI. <br>Required: ${minRequiredWidth}px (width) x ${minRequiredHeight}px (height). <br>Uploaded: ${imageWidth}px (width) x ${imageHeight}px (height).`;

              console.warn(warningMessage);

              // Create and append a warning message
              const warningElement = document.createElement("p");
              warningElement.innerHTML = warningMessage; // Use innerHTML to inject the HTML content
              warningElement.classList.add("warning_p");
              warningsElement.appendChild(warningElement);

              //show new warning
              ///HIDING WARNINGS FOR SOMETIME
              // $("#preview-warning").addClass("active");
              ///HIDING WARNINGS FOR SOMETIME
              ///HIDING BUUTON DISABLE FEATURE FOR SOMETIME
              // $(".btn_block").removeClass("active"); //hiding add to cart button when image is unselected
              $(".btn_block").addClass("active");
              ///HIDING BUUTON DISABLE FEATURE FOR SOMETIME
              //makeing warning checkbox uncheck
              $("#confirm_photo").prop("checked", false);

              // Reset `showCheckbox` after displaying the message
              showCheckbox = false;
            } else {
              console.log(
                "Image doesn't match minimum requirements, but no warnings were triggered."
              );
              //show new warning
              $("#preview-warning").removeClass("active");
            }
          } catch (error) {
            // Catch any errors that occur during imageUpload
            console.error("Error during image upload:", error);
          }
        } else {
          // If the image meets the minimum requirements, just proceed with the upload
          //hide the warning if its there
          $("#preview-warning").removeClass("active");
          try {
            // Call the imageUpload function and wait for it to complete
            console.log("handleImageUpload in else - before imageUpload call");
            await imageUpload();
            console.log("handleImageUpload in else - after imageUpload call");

            cropper.destroy(); // Destroy the Cropper instance
            document.getElementById("image-editor-modal").style.display =
              "none"; // Hide the modal
            $("body").removeClass("overflow_hidden");

            console.log(
              "Image uploaded successfully and meets all requirements."
            );
          } catch (error) {
            console.error("Error during image upload:", error);
          }
        }
      }

      try {
        // Call handleImageUpload and wait for it to complete
        await handleImageUpload();

        // Continue with the rest of the logic after the image has been uploaded
        console.log(
          "Full-quality image upload process is complete without error!"
        );
        $("#uploading-modal").fadeOut();
      } catch (error) {
        console.error("Error in handleImageUpload:", error);
      }
    };
    document
      .getElementById("crop-save-btn")
      .addEventListener("click", function () {
        $("#uploading-modal").css("z-index", "2000000000000000");
        $("#image-editor-modal").css("background", "transparent");
        document.getElementById("uploading-modal").style.display = "block";
        compressAndStoreImage(); // To compress and store the image
        downloadFullQualityImage(); // To download the full-quality image
      });
  }

  //////////////  CODE FOR CUSTOM PRINTS  //////////////

  //////////////  CODE FOR custom print collection page  //////////////
  // $(document).on('click', '.cp_filter', function() {
  //   // Get the value of the data-custom-print attribute
  //   var targetId = $(this).attr('data-custom-print');

  //   //check if the current click filter has active class
  //   if($(this).hasClass("active")){
  //     $('#' + targetId).find(".facet-checkbox__text").click();
  //     $(this).removeClass("active");
  //     console.log("in iffff");
  //   }else{
  //     // console.log("in elseeee");
  //     $(".cp_filter.active").each(function() {
  //       var targetIdn = $(this).attr('data-custom-print');
  //       console.log("in elseeee 3: ", targetIdn);
  //       $('#' + targetIdn).find(".facet-checkbox__text").click();
  //       $(this).removeClass("active");
  //       setTimeout(function() {

  //       }, 800);
  //     });

  //     //add clas active to current slected filter option\
  //     $(this).addClass("active");
  //     // Find the element with the matching ID and trigger a click
  //     $('#' + targetId).find(".facet-checkbox__text").click();
  //     console.log("in elseeee 2 800: ", targetId);
  //   //   setTimeout(function() {
  //   // }, 800);
  //   }

  // });
  //////////////  CODE FOR custom print collection page  //////////////

  //////////////  CODE FOR SHOPIFY FORMS APP STYLING  //////////////

  const formContainer = document.querySelector(".business_form");

  if (formContainer) {
    const observer = new MutationObserver((mutationsList, observer) => {
      const form = formContainer.querySelector("form-embed");

      if (form) {
        observer.disconnect(); // Stop observing once the form is found
        const shadow = form.shadowRoot;

        const sheet = new CSSStyleSheet();

        if (window.innerWidth <= 770) {
          sheet.insertRule(`
            form {
              padding-top: 10px !important;
            }
          `);
        } else {
          sheet.insertRule(`
            form {
              padding-top: 20px !important;
            }
          `);
        }
        sheet.insertRule(`
          ._container_3eyaa_70 {
            display: block !important;
          }
        `);
        sheet.insertRule(`
          ._formContainer_stahb_30 {
            min-width: 100% !important;
          }
        `);

        //hiding labels
        sheet.insertRule(`
          label {
            display: none !important;
          }
        `);
        //hiding dropdown label
        sheet.insertRule(`
          ._label_1yit2_10 {
            display: none !important;
          }
        `);
        //setting for input alignment and arrangment
        sheet.insertRule(`          
          form {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important; /* Two equal columns */
            grid-template-rows: auto !important; /* Automatically adjust row height */
          }
        `);
        if (window.innerWidth <= 510) {
          sheet.insertRule(`
            form {
              gap: 16px !important; /* Space between grid items */
              grid-template-areas:
                "first-name first-name"
                "last-name last-name"
                "email email"
                "phone-area phone-area"
                "msg msg"
                "submit submit" !important;
            }
          `);
        } else {
          sheet.insertRule(`
            form {
              gap: 16px !important; /* Space between grid items */
              grid-template-areas:
                "first-name last-name"
                "email email"
                "phone-area phone-area"
                "msg msg"
                "submit submit" !important;
            }
          `);
        }
        //comment
        sheet.insertRule(`
          form > ._formFieldContainer_1ydxd_5:nth-child(1) {
            grid-area: first-name !important; /* First input field */
          }
        `);
        sheet.insertRule(`          
          form > ._formFieldContainer_1ydxd_5:nth-child(2) {
            grid-area: last-name !important; /* Second input field */
          }
        `);
        sheet.insertRule(`
          ._formFieldContainer_1ydxd_5:nth-child(3) {
            grid-area: email !important; /* Email field */
          }
        `);
        sheet.insertRule(`
          ._formFieldContainer_1ydxd_5:nth-child(5) {
            grid-area: msg !important; /* Message field */
          }
        `);
        // sheet.insertRule(`
        //   ._selectContainer_1yit2_6 {
        //     grid-area: business-need !important; /* Dropdown */
        //   }
        // `);
        sheet.insertRule(`
          ._formPhoneInputContainer_1ym3p_6 {
            grid-area: phone-area !important; /* Dropdown */
          }
        `);
        sheet.insertRule(`
          button._formSubmitButton_1ll8d_81 {
            grid-area: submit !important; /* Submit button */
            font-family: "abolition", sans-serif !important;
            font-weight: 400 !important;
            font-style: normal !important;
            letter-spacing: 1pt !important;
            border-radius: 0 !important;
            color: white !important;
            background-color: #37003c !important;
            filter: unset !important;
            transition: .25s ease-in-out !important;
          }
        `);
        //comment

        if (window.innerWidth <= 510) {
          sheet.insertRule(`
            button._formSubmitButton_1ll8d_81 {
              font-size: 20px !important;
              padding: 8px 20px !important;
            }
          `);
        } else {
          sheet.insertRule(`
            button._formSubmitButton_1ll8d_81 {
              font-size: 26px !important;
              padding: 10px !important;
              width: 50% !important;
            }
          `);
        }

        sheet.insertRule(`
          button._formSubmitButton_1ll8d_81:hover {
            background-color: #FF0057 !important; /* New background color on hover */
          }
        `);
        //setting for input alignment and arrangment

        //hiding disclaimer
        sheet.insertRule(`
          ._formDisclaimer_1ll8d_37 {
            display: none !important;
          }
        `);

        sheet.insertRule(`
          input, textarea {
            border-radius: 0px !important;
            border: none !important;
            font-family: "proxima-nova", sans-serif !important;
            font-weight: 400 !important;
            font-style: normal !important;
            color: #5f4262 !important; 
            border: 1px solid rgba(69, 0, 64, 1) !important; 
            box-shadow: none !important;
            border-radius: 4px !important;
          }
        `);
        sheet.insertRule(`
          input::placeholder, textarea::placeholder, .business-need-text {
            font-family: "proxima-nova", sans-serif !important;
            font-weight: 400 !important;
            font-style: normal !important;
            color: #5f4262 !important; 
            opacity: 1 !important;
            text-transform: uppercase !important;
          }
        `);
        if (window.innerWidth <= 770) {
          sheet.insertRule(`
            input::placeholder, textarea::placeholder, .business-need-text {
              font-size: 15px !important;
            }
          `);
          sheet.insertRule(`
            input, textarea {
              font-size: 15px !important;
              padding: 7px !important;
            }
          `);
        } else {
          sheet.insertRule(`
            input::placeholder, textarea::placeholder, .business-need-text {
              font-size: 16px !important;
            }
          `);
          sheet.insertRule(`
            input, textarea {
              font-size: 16px !important;
              padding: 10px !important;
            }
          `);
        }
        sheet.insertRule(`
          input:focus-visible, textarea:focus-visible {
            box-shadow: none !important;
          }
        `);
        // sheet.insertRule(`
        //   button[aria-expanded] span._selectToggleText_1yit2_25{
        //     font-family: "proxima-nova", sans-serif !important;
        //     font-weight: 400 !important;
        //     font-style: normal !important;
        //     color: #5f4262 !important;
        //   }
        // `);

        sheet.insertRule(`
          button[aria-expanded]{
            border-radius: 4px !important;
            border: none !important;            
            border: 1px solid rgba(69, 0, 64, 1) !important; 
            box-shadow: none !important;
          }
        `);

        if (window.innerWidth <= 770) {
          // sheet.insertRule(`
          //   button[aria-expanded] span._selectToggleText_1yit2_25 {
          //     font-size: 15px !important;
          //   }
          // `);
          sheet.insertRule(`
            button[aria-expanded] {
              padding: 7px !important;
            }
          `);
        } else {
          // sheet.insertRule(`
          //   button[aria-expanded] span._selectToggleText_1yit2_25 {
          //     font-size: 16px !important;
          //   }
          // `);
          sheet.insertRule(`
            button[aria-expanded] {
              padding: 10px !important;
            }
          `);
        }
        sheet.insertRule(`
          ._arrowDownIcon_1yit2_19 svg path{
            fill: rgba(69, 0, 64, 1) !important;
          }
        `);
        sheet.insertRule(`
          ._arrowDownIcon_1yit2_19 svg {
            opacity: .5 !important;
          }
        `);

        // Add placeholders to inputs
        const inputs = shadow.querySelectorAll("input, textarea");
        inputs.forEach((input) => {
          switch (input.id) {
            case "first_name":
              input.placeholder = "first name";
              break;
            case "last_name":
              input.placeholder = "last name";
              break;
            case "email":
              input.placeholder = "email address";
              break;
            case "custom#message":
              input.placeholder = "message";
              break;
            default:
              break;
          }
        });

        // Apply the styles to the Shadow DOM
        shadow.adoptedStyleSheets.push(sheet);

        // //adding placeholder to dropdown
        // // Get the select toggle text span
        // const selectToggleText = shadow.querySelector('span._selectToggleText_1yit2_25');
        // //getting innerhtml
        // var inneHt = $(".business_form").attr("data-temp");
        // if(inneHt == 'photography-landing-page'){
        //   inneHt = 'Photography Industry';
        // }else{
        //   inneHt = 'Business Need';
        // }

        // if (selectToggleText) {

        //   // Wrap 'Business Need' inside a new span with a specific class
        //   const businessNeedSpan = document.createElement('span');
        //   businessNeedSpan.classList.add('business-need-text'); // Add a class for future targeting
        //   businessNeedSpan.innerHTML = inneHt;

        //   // Only wrap if it's not already wrapped
        //   if (!selectToggleText.querySelector('.business-need-text')) {
        //     selectToggleText.innerHTML = ''; // Clear any existing content
        //     selectToggleText.appendChild(businessNeedSpan); // Append the wrapped "Business Need"
        //   }
        // }

        // // Observe changes to the main span's content
        // const button = shadow.querySelector('button[aria-expanded]');
        // const span = shadow.querySelector('span._selectToggleText_1yit2_25');

        // const buttonObserver = new MutationObserver(() => {
        //   // Check if the content of the span has changed
        //   const businessNeedSpan = span.querySelector('.business-need-text');
        //   if (span.innerHTML !== inneHt && businessNeedSpan) {
        //     // If the span content changes, hide the "Business Need" wrapped in the new span
        //     businessNeedSpan.style.display = 'none';
        //   } else {
        //     // Ensure the "Business Need" span is visible if the content is unchanged
        //     if (businessNeedSpan) {
        //       businessNeedSpan.style.display = 'inline'; // or 'block', based on your design
        //     }
        //   }
        // });

        // // Observe changes to the button's aria-expanded attribute and the span's content
        // buttonObserver.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });
        // buttonObserver.observe(span, { childList: true });

        // Add a class to the form container for further customization
        formContainer.classList.add("loaded");
      }
    });

    // Observe for changes only within the custom section
    observer.observe(formContainer, { childList: true, subtree: true });

    // Resize event listener to act like media query
    window.addEventListener("resize", () => {
      // Trigger MutationObserver actions based on screen size
      observer.takeRecords(); // Forces MutationObserver to re-evaluate
    });
  }
  //////////////  CODE FOR SHOPIFY FORMS APP STYLING  //////////////
});

function getCurrentCollectionName() {
  var pathArray = window.location.pathname.split("/");
  var collectionIndex = pathArray.indexOf("collections");
  if (collectionIndex !== -1 && collectionIndex + 1 < pathArray.length) {
    return pathArray[collectionIndex + 1];
  }
  return null; // Return null if collection name not found
}

function scrolt_to(storedProductId) {
  var $productGrid = $(".product-grid");
  // $('html, body').animate({
  //     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
  // }, 700);
  if (storedProductId) {
    console.log("consoling: " + storedProductId);
    var $storedProduct = $("#" + storedProductId);
    if ($storedProduct.length) {
      // $('html, body').animate({
      //     scrollTop: $storedProduct.offset().top - ($(window).height() * 0.25)
      // }, 800);
      window.scrollTo({
        top: $storedProduct.offset().top - $(window).height() * 0.25,
        behavior: "auto", // No animation
      });
      console.log("Scrolled to:", $storedProduct);
      console.log("Scrolled id:", storedProductId);
    } else {
      // $('html, body').animate({
      //     scrollTop: $productGrid.offset().top - ($(window).height() * 0.25)
      // }, 800);
      // window.scrollTo({
      //   top: $productGrid.offset().top + $productGrid.height() * 0.95,
      //   behavior: "auto", // No animation
      // });
      // console.log("Not Scrolled to:", $storedProduct);
      // console.log("Not Scrolled id:", storedProductId);
    }
    console.log("scrolllllled: ", $storedProduct);
  } else {
    // var $productGrid = $(".product-grid");
    // // $('html, body').animate({
    // //     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
    // // }, 700);
    // window.scrollTo({
    //   top: $productGrid.offset().top + $productGrid.height() * 0.15,
    //   behavior: "auto", // No animation
    // });
  }
}

async function checkCurrentCollection() {
  // alert();
  var currentCollection = getCurrentCollectionName();
  var storedCollection = localStorage.getItem("currentCollection");
  var storedPage = parseInt(localStorage.getItem("currentPage")) || 1;
  var storedProductId = localStorage.getItem("currentPrdScrollID");
  console.log("current collection: " + currentCollection);
  console.log("storedCollection collection: " + storedCollection);
  console.log("current storedPage: " + storedPage);

  if (currentCollection === storedCollection) {
    // Do something if current collection matches stored collection
    // console.log('Current collection matches stored collection:', currentCollection);

    // localStorage.setItem("currentPage", 1);
    var currentPage = 1;
    var currentProdGrid = "";
    var totalPages = parseInt($("[data-total-pages]").val());
    console.log("totalpages: " + totalPages);

    const loadMoreRequests = [];

    //setting current page in load more releated hidden element
    $("[data-current-page]").val(storedPage);

    while (currentPage < storedPage) {
      currentPage++;
      localStorage.setItem("currentPage", currentPage);
      var nextUrl = $("[data-next-url]")
        .val()
        .replace(/page=[0-9]+/, "page=" + currentPage);

      loadMoreRequests.push(
        $.ajax({
          url: nextUrl,
          type: "GET",
          dataType: "html",
        }).done(function (responseHTML) {
          currentProdGrid += $(responseHTML).find(".product-grid").html();
        })
      );

      // console.log('Current collection clicked!!');
      // console.log('storedPage!! ', storedPage);
    }

    // Wait for all AJAX requests to complete
    await Promise.all(loadMoreRequests);

    // Append the collected product grids to the page
    $(".product-grid").append(currentProdGrid);

    // setTimeout(scrolt_to(storedProductId), 400);
    if (currentPage == totalPages) {
      $(".js-load-more-product-collection").removeClass("keep_loading");
      $(".load-more_wrap").hide();
    }

    // console.log("currentProdGrid: " + currentProdGrid);
  } else {
    // console.log('Current collection does not match stored collection');
    localStorage.setItem("currentCollection", currentCollection);
    localStorage.setItem("currentPage", 1);
  }
}
